class CalendarManager {
    constructor(calendarSelector, datepickerSelector) {
        this.calendarSelector = calendarSelector;
        this.datepickerSelector = datepickerSelector;
        this.calendar = null;
        this.airDatepicker = null;
        this.events = [];
        this.start = null;
        this.end = null;
        this.viewMode = null;
        this.range = ['', ''];
        this.currentUser = null;
        this.currentUserRights = null;
        this.isSyncing = false;
        this.rangeIniziale = ['', ''];
        this.afterSaveHandler = null;
        // this.init();
    }

    initCalendario() {
        this.setupModals();
        this.setupDatePicker();
        this.setupCalendar();
        this.setupCalendarView();
    }

    initWidget() {
        document.addEventListener('appBuilt', () => {
            application.ModalManagerIstance.register('eventModal', null, null);
        })
        const date = moment(); // Data corrente
        const firstDay = date.startOf('month').format('YYYY-MM-DD'); // Primo giorno del mese corrente
        const lastDay = date.endOf('month').format('YYYY-MM-DD');   // Ultimo giorno del mese corrente
        $('#daySelect').val(moment().format('YYYY-MM-DD'));
        //this.start = firstDay;
        //this.end = lastDay;
        this.range[0] = firstDay;
        this.range[1] = lastDay;

        this.handleChangeDateViewWidget('', '');
        // this.setupModals();
        this.setupDatePickerWidget();
        // this.setupModals();
        this.setupWidgetModalEvent();
        $('#btnToday').on('click', (e) => {
            e.preventDefault();
            this.handleTodayWidget();
        });
    }

    initNewEvent(cliente, commessa, offerta, callback) {
        
        document.addEventListener('appBuilt', () => {
            application.ModalManagerIstance.register('eventModal', null, null);
        });
        $('#cliente-select').val(cliente);
        $('#commessa-select').val(commessa);
        $('#offerta-select').val(offerta);
        this.afterSaveHandler = callback;
        this.setupModalEventWork(cliente, commessa, offerta);
    }

    initEditEvent(callback) {

        document.addEventListener('appBuilt', () => {
            application.ModalManagerIstance.register('eventModal', null, null);
        })
        

        this.range[0] = '1900-01-01';
        this.range[1] = '2099-12-31';
        
        this.handleEventsListLoad();
        this.afterSaveHandler = callback;
        
        this.setupEventsList();

    }



    setupModalEventWork(cliente, commessa, offerta) {
        application.LoadingModalIstance.Build(
            'Attendere',
            'Caricamento dati in corso...'
        );
        try {

            this.Setup(0, [], this.range[0], this.range[1], cliente, commessa, offerta)
                .then((response) => {
                    const calendari = $('#calendario');
                    const priorita = $('#priority');
                    const proprietario = $('#creator_user');
                    const utenti = $('#user-select');
                    const timeUnit = $('#time-unit-selector');
                    const commesse = $('#commessa-select');
                    const offerte = $('#offerta-select'); // Corretto Lorenzo 25/1/2025 , ID sbagliato, plurale invece di singolare, const offerte = $('#offerte-select');
                    const clienteLbl = $('#cliente');
                    const calendarBtnAddEvent = $('#btnEventModal');


                    //OK
                    for (let i = 0; i < response.userCalendars.length; i++) {

                        if (!response.userCalendars[i].AllUsers && !response.userCalendars[i].IsPersonal) {
                            calendari.addClass('freeusers_' + response.userCalendars[i].Id);
                        }
                    }

                    this.currentUser = response.users.CurrentIdSelected;
                    this.currentUserRights = response.rights;
                    if (calendarBtnAddEvent) {
                        if (this.currentUserRights.canAddEvent === false) {
                            calendarBtnAddEvent.addClass('d-none')
                        } else {
                            calendarBtnAddEvent.removeClass('d-none')
                        }
                    }


                    if (calendari) {
                        this.renderSelectDropdown(
                            calendari,
                            response.userCalendars,
                            'Title',
                            'Id',
                            true,
                            0
                        );
                    }

                    if (priorita) {
                        this.renderSelectDropdown(
                            priorita,
                            response.eventPriorities.Items,
                            'Description',
                            'Id',
                            response.eventPriorities.CanEdit,
                            response.eventPriorities.CurrentIdSelected
                        );
                    }

                    if (proprietario) {
                        this.renderSelectDropdown(
                            proprietario,
                            response.users.Items,
                            'Description',
                            'Id',
                            response.users.CanEdit,
                            response.users.CurrentIdSelected
                        );
                    }

                    if (utenti) {
                        this.renderSelectDropdown(
                            utenti,
                            response.assignableUsers.Items,
                            'Description',
                            'Id',
                            response.assignableUsers.CanEdit,
                            response.assignableUsers.CurrentIdSelected
                        );
                    }

                    if (timeUnit) {
                        this.renderSelectDropdown(
                            timeUnit,
                            response.timeUnits.Items,
                            'Description',
                            'Id',
                            true,
                            0
                        );
                    }

                    if (clienteLbl) {
                        clienteLbl.val(response.customer.Clienti.Items[0].Description);
                    }

                    this.renderSelectDropdown(
                        commesse,
                        response.customer.Commesse.Items,
                        'Description',
                        'Id',
                        false,
                        commessa
                    );

                    this.renderSelectDropdown(
                        offerte,
                        response.customer.Offerte.Items,
                        'Description',
                        'Id',
                        false,
                        offerta
                    );

                    $('#cliente').val(response.customer.Clienti.Items[0].Description);

                    //button del widget
                    calendarBtnAddEvent.on('click', (e) => {
                        e.preventDefault();
                        let currentDay = moment().add(1, 'days').format('YYYY-MM-DD');
                        if ($('#daySelect')) {
                            currentDay = moment($('#daySelect').val()).format('YYYY-MM-DD');
                        }
                        let start = moment().format('HH:mm');
                        let end = moment().add(1, 'hours').format('HH:mm');

                        

                        $('#data_inizio').val(currentDay);
                        $('#data_fine').val(currentDay);
                        $('#ora_inizio').val(start);
                        $('#ora_fine').val(end);

                        $('#data_inizio').attr('min', moment().format('YYYY-MM-DD'));
                        $('#data_fine').attr('min', moment().format('YYYY-MM-DD'));

                        $('#maxDateTimeTo').attr('min', moment().format('YYYY-MM-DD'));
                        $('#units').val(0);
                        $('#maxItems').val(0);
                        $('#idOriginal').val(0);
                        $('#updateType').val(0);
                        $('#idStato').val(0);

                        $('#cliente').attr('disabled', true);
                        $('#commessa-select').attr('disabled', true);
                        $('#offerta-select').attr('disabled', true);
                        $('#nota').val('');
                        $('#nota').text('');
                        setTimeout(function () { $('#nota').removeClass('sp_autosize_worked'); }, 50);
                        setTimeout(function () { $('#nota').removeClass('sp_autosize_worked'); }, 5000);



                        //$('#type').attr('disabled', true);

                        $('#user-select').val(0);
                        //$('#cliente').val('');

                        $('#btn-add-event').removeClass('d-none');
                        $('#eventModalLabel').text('Nuovo Evento');
                        $('#badgeEventCompletato').addClass('d-none');
                        $('#badgeEventAnnullato').addClass('d-none');
                        $('#badgeEventDaCompletare').addClass('d-none');
                        //$('#eventModal').modal('show');

                        application.ModalManagerIstance.show('eventModal');
                    });


                    $('#btn-add-event').on('click', (e) => {
                        e.preventDefault();
                        this.handleEventSave();
                    });

                    $('#closeModalEvent').on('click', (e) => {
                        e.preventDefault();
                        this.closeModalEvent();
                    });

                    $('#calendario').on('change', (e) => {
                        e.preventDefault();
                        $('#user-select').attr('disabled', true);

                        if (cliente > 0 && e.target.value > 0) {
                            const elements = this.serializeEvent();
                            const cliente = elements.cliente_select.val();
                            const commessa = elements.commessa_select.val();
                            const offerta = elements.offerta_select.val();
                            this.handleChangeCalendario(
                                e.target.value,
                                cliente,
                                commessa,
                                offerta
                            );
                        }

                        if (e.target.value !== '0') {
                            $('.select2-selection__rendered').html('');
                            $('.sp_schedule_users_selection').prop('title', "La tipologia di calendario non consente la selezione individuale di utenti");
                            if ($('#calendario').hasClass('freeusers_' + e.target.value)) {
                                $('#user-select').attr('disabled', false);
                                $('.sp_schedule_users_selection').prop('title', "La tipologia di calendario consente di associare l'evento ad una lista di utenti a scelta");
                            }

                        }



                    });







                    $('#ripeti-evento').on('change', function (e) {
                        e.preventDefault();
                        if (this.checked) {
                            $('#row-container').collapse('show');
                            $('#has-recurrences').val('True');
                        } else {
                            $('#has-recurrences').val('False');
                            $('#row-container').collapse('hide');
                            $('#custom-recurrences').collapse('hide');
                            $('#units').val(0);
                            $('#time-unit-selector').prop('selectedIndex', 0);
                            $('#recurrence-frequency').prop('selectedIndex', 0);
                            $('#maxDateTimeTo').prop('disabled', true).val(null);
                            $('#maxItems').prop('disabled', true).val(0);
                            $('#number-recurrence, #date-recurrence').prop('checked', false);
                        }
                    });

                    $('#recurrence-frequency').on('change', function (e) {
                        e.preventDefault();
                        if (this.value == 5) {
                            // 5 -> option "Personalizza"
                            $('#custom-recurrences').collapse('show');
                        } else {
                            $('#custom-recurrences').collapse('hide');
                        }
                    });

                    $('#number-recurrence, #date-recurrence').on('change', function () {
                        if ($(this).attr('id') === 'number-recurrence') {
                            if ($(this).is(':checked')) {
                                // Se "number-recurrence" è attivato
                                $('#date-recurrence').prop('checked', false);
                                $('#maxDateTimeTo').prop('disabled', true).val(null);
                                $('#maxItems').prop('disabled', false);
                            } else {
                                $('#maxItems').prop('disabled', true).val(0);
                            }
                        } else if ($(this).attr('id') === 'date-recurrence') {
                            if ($(this).is(':checked')) {
                                $('#number-recurrence').prop('checked', false);
                                $('#maxItems').prop('disabled', true).val(0);
                                $('#maxDateTimeTo').prop('disabled', false);
                            } else {
                                $('#maxDateTimeTo').prop('disabled', true).val(null);
                            }
                        }
                    });

                    $('#tipologia-switch-calendario').on('change', function (e) {
                        e.preventDefault();
                        if (this.checked) {
                            $('#tipologia-nuovo-calendario').collapse('show');
                        } else {
                            $('#tipologia-nuovo-calendario').collapse('hide');
                        }
                    });

                    $('#user-select').select2({
                        theme: 'bootstrap-5',
                        width: $(this).data('width')
                            ? $(this).data('width')
                            : $(this).hasClass('w-100')
                                ? '100%'
                                : 'style',
                        placeholder: $(this).data('placeholder'),
                        closeOnSelect: false,
                        templateResult: function (data, container) {
                            
                            if (data.element) {
                                $(container).prop('disabled', false);
                                if ($(data.element).attr("data-is-active") === 'true') {
                                    $(container).css("display", "block");
                                } else {
                                    if ($(data.element).is(':selected')) {
                                        $(container).css("display", "block");
                                        $(container).prop('disabled', true);
                                    } else {
                                        $(container).css("display", "none");
                                    }
                                }
                            }
                            return data.text;
                        }
                    });
                })
                .catch((error) => {
                    throw new Error(error);
                });
        } catch (e) {
            alert(`Ops! Qualcosa è andato storto.\n${e}`);
            
        } finally {
            setTimeout(() => {
                //application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
                
            }, 700);
        }
    }

    refreshWidget() {
        const date = moment(); // Data corrente
        const firstDay = date.startOf('month').format('YYYY-MM-DD'); // Primo giorno del mese corrente
        const lastDay = date.endOf('month').format('YYYY-MM-DD');   // Ultimo giorno del mese corrente
        //this.start = firstDay;
        //this.end = lastDay;
        this.range[0] = firstDay;
        this.range[1] = lastDay;
        this.handleChangeDateViewWidget('', '');

    }

    setupModals() {
        document.addEventListener('appBuilt', () => {
            application.ModalManagerIstance.register(
                'createCalendarModal',
                null,
                null
            );
            application.ModalManagerIstance.register('eventModal', null, null);
        });
    }

    setupDatePicker() {
        this.airDatepicker = new AirDatepicker(this.datepickerSelector, {
            inline: true,
            locale: AircalendarIt,
            dateFormat: 'MMMM yyyy',
            navTitles: {
                days: 'MMMM yyyy',
            },
            view: 'days',
            onRenderCell: ({ date, cellType }) => {
                if (cellType === 'day') {
                    return this.renderCellConfig(date, cellType);
                }
                return {}; // Nessuna personalizzazione per mesi/anni
            },
            onChangeViewDate: ({ month, year, decade }) => {
                if (!this.isSyncing) {
                    //isSyncing = true;
                    let calendarView = this.calendar.view.type;

                    if (calendarView != 'dayGridMonth') {
                        
                        const selector = document.getElementById('view-selector');
                        if (selector) {
                            selector.value = 'dayGridMonth';
                            selector.dispatchEvent(new Event('change', { bubbles: true }));
                        } 
                    }
                    const momentDate = moment(`${year}-${month + 1}-01`).format(
                        'YYYY-MM-DD'
                    );

                    this.calendar.gotoDate(momentDate);
                    //    isSyncing = false;
                }
            },
        });
    }

    setupDatePickerWidget() {
        this.airDatepicker = new AirDatepicker(this.datepickerSelector, {
            inline: true,
            locale: AircalendarIt,
            dateFormat: 'MMMM yyyy',
            navTitles: {
                days: 'MMMM yyyy',
            },
            view: 'days',
            onRenderCell: ({ date, cellType }) => {
                if (cellType === 'day') {
                    return this.renderCellConfig(date, cellType);
                }
                return {}; // Nessuna personalizzazione per mesi/anni
            },
            onChangeViewDate: ({ month, year, decade }) => {
                
                const firstDay = moment(`${year}-${month + 1}`, "YYYY-MM").startOf('month');

                const lastDay = moment(`${year}-${month + 1}`, "YYYY-MM").endOf('month');

                this.handleChangeDateViewWidget(firstDay.format('YYYY-MM-DD'), lastDay.format('YYYY-MM-DD'));

            },
            onSelect: ({ date, formattedDate, datepicker }) => {
                

                $('#events').empty();
                const dateToFind = moment(date).format('YYYY-MM-DD');
                const today = moment().format('YYYY-MM-DD');

                const dayOfMonth = moment(date).date();
                const dayName = moment(date).format('dddd');
                const monthName = moment(date).format('MMMM');
                const yearName = moment(date).format('YYYY');

                if (dateToFind >= today) {
                    $('#daySelect').val(dateToFind);
                } else {
                    $('#daySelect').val(today);
                }

                if (dateToFind === today) {
                    $('#eventsHeader').empty().text('Oggi');
                } else {
                    $('#eventsHeader').empty().text(`${dayName} ${dayOfMonth} ${monthName} ${yearName}`);
                }

                const filteredEvents = this.events.filter(event => {
                    if (event.start) {
                        return event.start.includes(dateToFind);
                    }
                    return false;
                });
                if (filteredEvents) {
                    const ulElement = document.getElementById('events');
                    filteredEvents.forEach((event, index) => {
                        // Crea un nuovo elemento <li>

                        const liElement = document.createElement('li');
                        liElement.classList.add('widget-event');
                        let idPriority = event.idPriority;
                        let title = event.description;
                        let timeText = moment(event.start).format('HH:mm');
                        let icon = '';
                        let status = event.idStato;
                        let event_class = '';
                        let hour_class = '';

                        if (status == 92) { event_class = "sp_underlined" };
                        if (status == 91) { hour_class = "sp_schedule_completed" };

                        if (idPriority == 1) {
                            icon = '<i class="bi bi-flag-fill text-white"></i>';// 'per mantenere lo spazio metto in bianco fittizio
                        } else if (idPriority == 2) {
                            icon = '<i class="bi bi-flag-fill" style="color: #eca740;"></i>';
                        } else if (idPriority == 3) {
                            icon = '<i class="bi bi-flag-fill text-danger"></i>';
                        } else {
                        }

                        // Imposta il contenuto dell'elemento <li>
                        liElement.innerHTML = `
                                          <span class="${event_class}" title="${timeText} - ${title}"  >
                                            <b><span class="event-time ${hour_class}" >${timeText} | </span></b>
                                            <span class="event-title" >${title}</span>
                                          </span>
                                          <b>
                                            <span class="event-icon pl-1">${icon}</span>
                                          </b>                                          
                                        `

                        liElement.classList.add('d-flex', 'justify-content-between');
                        liElement.style.backgroundColor = "#fff";
                        liElement.style.borderLeft = "4px solid " + event.backgroundColor;
                        liElement.style.borderRadius = "0";
                        liElement.addEventListener('click', () => {
                            this.handleEventClick(event.id, event.idCalendar);
                        });
                        // Aggiungi il <li> al <ul>
                        ulElement.appendChild(liElement);
                    });
                }
            }
        });
    }


    handleEventsListLoad() {


        // Aggiorna il range e esegui la fetch
        this.range = ['1900-01-01', '2099-12-31'];


        $('#loading-overlay').attr('style', 'display:flex');

        let CalendarSchedules = document.getElementsByClassName("sp_calendarschedule");

        for (const CalendarSchedule of CalendarSchedules) {

            let Ids_Calendar;
            let Ids_Schedule;
            let Ids_position;

            Ids_position = CalendarSchedule.className.search('sp_id_');

            Ids_position = Ids_position + 6;

            Ids_Calendar = CalendarSchedule.className.substring(Ids_position, Ids_position + 8)

            Ids_position = Ids_position + 8;
            Ids_Schedule = CalendarSchedule.className.substring(Ids_position, Ids_position + 8)

            

            CalendarSchedule.addEventListener("click", () => {
                this.handleEventClick(Number(Ids_Schedule), Number(Ids_Calendar));
            });


        }




    }




    handleChangeDateViewWidget(firstDay, lastDay) {

        if (!firstDay || !lastDay) {
            // On load
            const today = moment();

            //  Riduzione del periodo di cache

            //  ORIGINALI
            //  const startRange = today.clone().subtract(1, 'month').startOf('month');
            //  const endRange = today.clone().add(3, 'months').endOf('month');

            const startRange = today.clone().startOf('month');
            const endRange = today.clone().endOf('month');
            //  Fine Riduzione del periodo di cache


            // Aggiorna il range e esegui la fetch
            this.range = [
                startRange.format('YYYY-MM-DD'),
                endRange.format('YYYY-MM-DD'),
            ];
            $('#loading-overlay').attr('style', 'display:flex');
            this.GetEvents([], this.range[0], this.range[1])
                .then((response) => {
                    if (response.IsSuccess) {
                        this.events = this.convertFirstLetterToLower(response.Data); // Aggiorna gli eventi


                        this.airDatepicker.update(); // Aggiorna il datepicker

                        $('#events').empty();

                        const dateToFind = moment().format('YYYY-MM-DD');
                        const filteredEvents = this.events.filter(event => {
                            if (event.start) {
                                return event.start.includes(dateToFind);
                            }
                            return false;
                        });

                        if (filteredEvents) {
                            const ulElement = document.getElementById('events');
                            filteredEvents.forEach((event, index) => {


                                // Crea un nuovo elemento <li>
                                const liElement = document.createElement('li');
                                liElement.classList.add('widget-event');
                                let idPriority = event.idPriority;
                                let title = event.description;
                                let timeText = moment(event.start).format('HH:mm');
                                let icon = '';

                                let status = event.idStato;
                                let event_class = '';
                                let hour_class = '';

                                if (status == 92) { event_class = "sp_underlined" };
                                if (status == 91) { hour_class = "sp_schedule_completed" };

                                if (idPriority == 1) {
                                    icon = '<i class="bi bi-flag-fill text-white"></i>';// 'per mantenere lo spazio metto in bianco fittizio
                                } else if (idPriority == 2) {
                                    icon = '<i class="bi bi-flag-fill"  style="color: #eca740;"></i>';
                                } else if (idPriority == 3) {
                                    icon = '<i class="bi bi-flag-fill text-danger"></i>';
                                } else {
                                }

                                // Imposta il contenuto dell'elemento <li>
                                liElement.innerHTML = `
                                          <span class="${event_class}" title="${timeText} - ${title}">
                                            <b><span class="event-time ${hour_class}"  >${timeText} | </span></b>
                                            <span class="event-title" >${title}</span>
                                          </span>
                                          <b>
                                            <span class="event-icon pl-1">${icon}</span>
                                          </b>                                          
                                        `

                                liElement.classList.add('d-flex', 'justify-content-between');
                                liElement.style.backgroundColor = "#fff";
                                liElement.style.borderLeft = "4px solid " + event.backgroundColor;
                                liElement.style.borderRadius = "0";
                                liElement.addEventListener('click', () => {
                                    this.handleEventClick(event.id, event.idCalendar);
                                });
                                // Aggiungi il <li> al <ul>
                                ulElement.appendChild(liElement);

                            });
                        }
                    }
                })
                .catch((error) => { })
                .finally(() => $('#loading-overlay').attr('style', 'display:none'));
            return; // Esci dopo aver fatto la fetch
        }

        // Se firstDay e lastDay sono forniti, controlla se rientrano nel range
        const startRange = moment(this.range[0], 'YYYY-MM-DD');
        const endRange = moment(this.range[1], 'YYYY-MM-DD');
        const startDate = moment(firstDay, 'YYYY-MM-DD');
        const endDate = moment(lastDay, 'YYYY-MM-DD');

        const isStartInRange = startDate.isSameOrAfter(startRange, 'day');
        const isEndInRange = endDate.isSameOrBefore(endRange, 'day');

        // Se le date rientrano nel range, esci senza fare nulla
        if (isStartInRange && isEndInRange) {
            return;
        }

        //  Riduzione del periodo di cache

        //  Altrimenti, calcola un nuovo range e fai la fetch
        //  Originali
        //  const newStartRange = startDate.clone().subtract(1, 'month').startOf('month');
        //  const newEndRange = endDate.clone().add(3, 'months').endOf('month');

        const newStartRange = startDate.clone().startOf('month');
        const newEndRange = endDate.clone().endOf('month');

        //  Fine Riduzione del periodo di cache


        this.range = [
            newStartRange.format('YYYY-MM-DD'),
            newEndRange.format('YYYY-MM-DD'),
        ];
        $('#loading-overlay').attr('style', 'display:flex');
        // Esegui la fetch per il nuovo intervallo
        this.GetEvents([], this.range[0], this.range[1])
            .then((response) => {
                if (response.IsSuccess) {
                    this.events = this.convertFirstLetterToLower(response.Data); // Aggiorna gli eventi
                    this.airDatepicker.update(); // Aggiorna il datepicker
                }
            })
            .catch((error) => { })
            .finally(() => $('#loading-overlay').attr('style', 'display:none'))
    }


    setupWidgetModalEvent() {
        application.LoadingModalIstance.Build(
            'Attendere',
            'Caricamento dati in corso...'
        );
        const calendarComponentSpecificSpinner = document.getElementById(
            'sidebar-content-loader'
        );
        try {
            ///application.ModalManagerIstance.show(application.LoadingModalIstance.Id);
            //calendarComponentSpecificSpinner.classList.remove('d-none');

            this.Setup(0, [], this.range[0], this.range[1]).then((response) => {
                const calendari = $('#calendario');
                //const calendariListContainer = $('#sidebar-dropdown-menu');
                const priorita = $('#priority');
                const proprietario = $('#creator_user');
                const utenti = $('#user-select');
                const timeUnit = $('#time-unit-selector');
                const calendarEventBtnAdd = $('#btnEventModal');

                var CalendarIDsWithFreeUsers = '';
                
                //OK
                for (let i = 0; i < response.userCalendars.length; i++) {
                    
                    if (!response.userCalendars[i].AllUsers && !response.userCalendars[i].IsPersonal) {
                        calendari.addClass('freeusers_' + response.userCalendars[i].Id);
                    }
                }
                
                
                this.currentUser = response.users.CurrentIdSelected;
                this.currentUserRights = response.rights;
                if (calendarEventBtnAdd) {
                    if (this.currentUserRights.canAddEvent === true) {
                        calendarEventBtnAdd.removeClass('d-none');
                    } else {
                        calendarEventBtnAdd.addClass('d-none');
                    }
                }


                if (calendari) {
                    this.renderSelectDropdown(
                        calendari,
                        response.userCalendars,
                        'Title',
                        'Id',
                        true,
                        0
                    );
                }
                //if (calendariListContainer) {
                //    this.renderCalendarList(
                //        calendariListContainer,
                //        responses[0].Data,
                //        'Title',
                //        'Id',
                //        true,
                //        0
                //    );
                //}

                // calendarComponentSpecificSpinner.classList.add('d-none');

                if (priorita) {
                    this.renderSelectDropdown(
                        priorita,
                        response.eventPriorities.Items,
                        'Description',
                        'Id',
                        response.eventPriorities.CanEdit,
                        response.eventPriorities.CurrentIdSelected
                    );
                }

                if (proprietario) {
                    this.renderSelectDropdown(
                        proprietario,
                        response.users.Items,
                        'Description',
                        'Id',
                        response.users.CanEdit,
                        response.users.CurrentIdSelected
                    );
                }

                if (utenti) {
                    this.renderSelectDropdown(
                        utenti,
                        response.assignableUsers.Items,
                        'Description',
                        'Id',
                        response.assignableUsers.CanEdit,
                        response.assignableUsers.CurrentIdSelected
                    );
                }

                if (timeUnit) {
                    this.renderSelectDropdown(
                        timeUnit,
                        response.timeUnits.Items,
                        'Description',
                        'Id',
                        true,
                        0
                    );
                }

                calendarEventBtnAdd.on('click', (e) => {
                    e.preventDefault();
                    let currentDay = moment().add(1, 'days').format('YYYY-MM-DD');
                    if ($('#daySelect')) {
                        currentDay = moment($('#daySelect').val()).format('YYYY-MM-DD');
                    }
                    let start = moment().format('HH:mm');
                    let end = moment().add(1, 'hours').format('HH:mm');

                    $('#data_inizio').val(currentDay);
                    $('#data_fine').val(currentDay);
                    $('#ora_inizio').val(start);
                    $('#ora_fine').val(end);

                    $('#data_inizio').attr('min', moment().format('YYYY-MM-DD'));
                    $('#data_fine').attr('min', moment().format('YYYY-MM-DD'));

                    $('#maxDateTimeTo').attr('min', moment().format('YYYY-MM-DD'));
                    $('#units').val(0);
                    $('#maxItems').val(0);
                    $('#idOriginal').val(0);
                    $('#updateType').val(0);
                    $('#idStato').val(0);

                    $('#cliente').attr('disabled', true);
                    $('#commessa-select').attr('disabled', true);
                    $('#offerta-select').attr('disabled', true);
                    $('#nota').val('');
                    $('#nota').text('');
                    setTimeout(function () { $('#nota').removeClass('sp_autosize_worked'); }, 50);
                    setTimeout(function () { $('#nota').removeClass('sp_autosize_worked'); }, 5000);

                    //$('#type').attr('disabled', true);

                    $('#user-select').val(0);
                    $('#cliente').val('');

                    $('#btn-add-event').removeClass('d-none');
                    $('#eventModalLabel').text('Nuovo Evento');
                    $('#badgeEventCompletato').addClass('d-none');
                    $('#badgeEventAnnullato').addClass('d-none');
                    $('#badgeEventDaCompletare').addClass('d-none');

                    document.querySelectorAll('#creator_user option').forEach(option => {
                        option.style.display = '';
                        if (option.getAttribute('data-is-active') === 'false') {
                            if (option.selected) {
                                option.disabled = true
                            } else {
                                option.style.display = 'none'; // Nasconde l'opzione
                            }
                        } else {
                            option.style.display = ''; // Mostra l'opzione (se necessario)
                        }
                    });
                    document.querySelectorAll('#user_select option').forEach(option => {
                        if (option.getAttribute('data-is-active') === 'false') {
                            option.style.display = 'none'; // Nasconde l'opzione
                        } else {
                            option.style.display = ''; // Mostra l'opzione (se necessario)
                        }
                    });
                    application.ModalManagerIstance.show('eventModal');

                });
                $('#btn-edit-event').on('click', (e) => {
                    e.preventDefault();
                    this.handleEventSave(1);
                });
                $('#btn-edit-events').on('click', (e) => {
                    e.preventDefault();
                    this.handleEventSave(2);
                });
                $('#btn-edit-all-events').on('click', (e) => {
                    e.preventDefault();
                    this.handleEventSave(3);
                });

                $('#btn-add-event').on('click', (e) => {
                    e.preventDefault();
                    this.handleEventSave();
                });

                $('#closeModalEvent').on('click', (e) => {
                    e.preventDefault();
                    this.closeModalEvent();
                });

                //OK
                $('#calendario').on('change', (e) => {
                    e.preventDefault();
                    $('#user-select').attr('disabled', true);
                    if (e.target.value === '0') {
                        $('#cliente').attr('disabled', true);
                        $('#cliente-select').val(0);
                        $('#commessa-select').attr('disabled', true);
                        $('#offerta-select').attr('disabled', true);
                        //$('#type').attr('disabled', true);
                    } else {
                        $('#cliente').attr('disabled', false);
                        
                        $('.select2-selection__rendered').html('');
                        $('.sp_schedule_users_selection').prop('title', "La tipologia di calendario non consente la selezione individuale di utenti");
                        if ($('#calendario').hasClass('freeusers_' + e.target.value)) {
                            $('#user-select').attr('disabled', false);
                            $('.sp_schedule_users_selection').prop('title', "La tipologia di calendario consente di associare l'evento ad una lista di utenti a scelta");
                            }

                        }

                    const cliente = $('#cliente-select').val();
                    if (cliente > 0 && e.target.value > 0) {
                        $('#commessa-select').attr('disabled', false);
                        $('#offerta-select').attr('disabled', false);
                        //$('#type').attr('disabled', false);

                        const elements = this.serializeEvent();
                        const cliente = elements.cliente_select.val();
                        const commessa = elements.commessa_select.val();
                        const offerta = elements.offerta_select.val();
                        this.handleChangeCalendario(
                            e.target.value,
                            cliente,
                            commessa,
                            offerta
                        );
                    }
                });

                $('#cliente-select').on('change', (e) => {
                    e.preventDefault();
                    const elements = this.serializeEvent();

                    const idCalendar = elements.calendario.val();
                    if (idCalendar > 0) {
                        $('#commessa-select').attr('disabled', false);
                        $('#offerta-select').attr('disabled', false);
                        //$('#type').attr('disabled', false);
                    }
                    const commessa = elements.commessa_select.val();
                    const offerta = elements.offerta_select.val();
                    this.handleChangeClienteSelezionato(
                        idCalendar,
                        $(e.target).val(),
                        commessa,
                        offerta
                    );
                });

                $('#commessa-select').on('change', (e) => {
                    e.preventDefault();
                    const elements = this.serializeEvent();

                    const idCalendar = elements.calendario.val();
                    const cliente = elements.cliente_select.val();
                    const offerta = elements.offerta_select.val();
                    this.handleChangeCommessa(
                        idCalendar,
                        cliente,
                        $(e.target).val(),
                        offerta
                    );
                });

                $('#offerta-select').on('change', (e) => {
                    e.preventDefault();
                    const elements = this.serializeEvent();
                    const idCalendar = elements.calendario.val();
                    const cliente = elements.cliente_select.val();
                    const commessa = elements.commessa_select.val();
                    this.handleChangeOfferta(
                        idCalendar,
                        cliente,
                        commessa,
                        $(e.target).val()
                    );
                });

                $('#ripeti-evento').on('change', function (e) {
                    e.preventDefault();
                    if (this.checked) {
                        $('#row-container').collapse('show');
                        $('#has-recurrences').val('True');
                    } else {
                        $('#has-recurrences').val('False');
                        $('#row-container').collapse('hide');
                        $('#custom-recurrences').collapse('hide');
                        $('#units').val(0);
                        $('#time-unit-selector').prop('selectedIndex', 0);
                        $('#recurrence-frequency').prop('selectedIndex', 0);
                        $('#maxDateTimeTo').prop('disabled', true).val(null);
                        $('#maxItems').prop('disabled', true).val(0);
                        $('#number-recurrence, #date-recurrence').prop('checked', false);
                    }
                });

                $('#recurrence-frequency').on('change', function (e) {
                    e.preventDefault();
                    if (this.value == 5) {
                        // 5 -> option "Personalizza"
                        $('#custom-recurrences').collapse('show');
                    } else {
                        $('#custom-recurrences').collapse('hide');
                    }
                });

                $('#number-recurrence, #date-recurrence').on('change', function () {
                    if ($(this).attr('id') === 'number-recurrence') {
                        if ($(this).is(':checked')) {
                            // Se "number-recurrence" è attivato
                            $('#date-recurrence').prop('checked', false);
                            $('#maxDateTimeTo').prop('disabled', true).val(null);
                            $('#maxItems').prop('disabled', false);
                        } else {
                            $('#maxItems').prop('disabled', true).val(0);
                        }
                    } else if ($(this).attr('id') === 'date-recurrence') {
                        if ($(this).is(':checked')) {
                            $('#number-recurrence').prop('checked', false);
                            $('#maxItems').prop('disabled', true).val(0);
                            $('#maxDateTimeTo').prop('disabled', false);
                        } else {
                            $('#maxDateTimeTo').prop('disabled', true).val(null);
                        }
                    }
                });

                $('#complete').on('click', (e) => {
                    e.preventDefault();
                    if (confirm("L'operazione non può essere annullata, si vuole proseguire?")) { this.handleCompleteEvent(); }
                    
                });

                $('#btn-undo-current').on('click', (e) => {
                    e.preventDefault();
                    if (confirm("L'operazione non può essere annullata, si vuole proseguire?")) { this.handleCancelEvent(1); }
                    
                });
                $('#btn-undo-current-and-next').on('click', (e) => {
                    e.preventDefault();
                    if (confirm("L'operazione non può essere annullata, si vuole proseguire?")) { this.handleCancelEvent(2); }
                });
                $('#btn-undo-series').on('click', (e) => {
                    e.preventDefault();
                    if (confirm("L'operazione non può essere annullata, si vuole proseguire?")) { this.handleCancelEvent(3); }
                });

                $('#btn-delete-event').on('click', (e) => {
                    e.preventDefault();
                    if (confirm("L'operazione non può essere annullata, si vuole proseguire?")) { this.handleEventDelete(1); }
                });
                $('#btn-delete-events').on('click', (e) => {
                    e.preventDefault();
                    if (confirm("L'operazione non può essere annullata, si vuole proseguire?")) { this.handleEventDelete(2); }
                });
                $('#btn-delete-all-events').on('click', (e) => {
                    e.preventDefault();
                    if (confirm("L'operazione non può essere annullata, si vuole proseguire?")) { this.handleEventDelete(3); }
                });
                $('#tipologia-switch-calendario').on('change', function (e) {
                    e.preventDefault();
                    if (this.checked) {
                        $('#tipologia-nuovo-calendario').collapse('show');
                    } else {
                        $('#tipologia-nuovo-calendario').collapse('hide');
                    }
                });
                //handleChangeAssignableUsers();
                //loading.hide();


                $('#user-select').select2({
                    theme: 'bootstrap-5',
                    width: $(this).data('width')
                        ? $(this).data('width')
                        : $(this).hasClass('w-100')
                            ? '100%'
                            : 'style',
                    placeholder: $(this).data('placeholder'),
                    closeOnSelect: false,
                    templateResult: function (data, container) {
                        $(container).prop('disabled', false);
                        if ($(data.element).attr("data-is-active") === 'true') {
                            $(container).css("display", "block");
                        } else {
                            if ($(data.element).is(':selected')) {
                                $(container).css("display", "block");
                                $(container).prop('disabled', true);
                            } else {
                                $(container).css("display", "none");
                            }
                        }
                        return data.text;
                    }
                });
            }).catch((error) => {
                throw new Error(error);
            });
        } catch (e) {
            alert(`Ops! Qualcosa è andato storto.\n${e}`);
            
            //calendarComponentSpecificSpinner.classList.add('d-none');
        } finally {
            setTimeout(() => {
                //application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
                
            }, 700);
        }
    }

    setupEventsList() {
        application.LoadingModalIstance.Build(
            'Attendere',
            'Caricamento dati in corso...'
        );
        
        const calendarComponentSpecificSpinner = document.getElementById(
            'sidebar-content-loader'
        );
        try {
            ///application.ModalManagerIstance.show(application.LoadingModalIstance.Id);
            //calendarComponentSpecificSpinner.classList.remove('d-none');

            this.Setup(0, [], this.range[0], this.range[1]).then((response) => {
                const calendari = $('#calendario');
                //const calendariListContainer = $('#sidebar-dropdown-menu');
                const priorita = $('#priority');
                const proprietario = $('#creator_user');
                const utenti = $('#user-select');
                const timeUnit = $('#time-unit-selector');
                const calendarEventBtnAdd = $('#btnEventModal');

                var CalendarIDsWithFreeUsers = '';

                //OK
                for (let i = 0; i < response.userCalendars.length; i++) {

                    if (!response.userCalendars[i].AllUsers && !response.userCalendars[i].IsPersonal) {
                        calendari.addClass('freeusers_' + response.userCalendars[i].Id);
                    }
                }


                this.currentUser = response.users.CurrentIdSelected;
                this.currentUserRights = response.rights;


                if (calendari) {
                    this.renderSelectDropdown(
                        calendari,
                        response.userCalendars,
                        'Title',
                        'Id',
                        true,
                        0
                    );
                }

                if (priorita) {
                    this.renderSelectDropdown(
                        priorita,
                        response.eventPriorities.Items,
                        'Description',
                        'Id',
                        response.eventPriorities.CanEdit,
                        response.eventPriorities.CurrentIdSelected
                    );
                }

                if (proprietario) {
                    this.renderSelectDropdown(
                        proprietario,
                        response.users.Items,
                        'Description',
                        'Id',
                        response.users.CanEdit,
                        response.users.CurrentIdSelected
                    );
                }

                if (utenti) {
                    this.renderSelectDropdown(
                        utenti,
                        response.assignableUsers.Items,
                        'Description',
                        'Id',
                        response.assignableUsers.CanEdit,
                        response.assignableUsers.CurrentIdSelected
                    );
                }

                if (timeUnit) {
                    this.renderSelectDropdown(
                        timeUnit,
                        response.timeUnits.Items,
                        'Description',
                        'Id',
                        true,
                        0
                    );
                }

                $('#btn-edit-event').on('click', (e) => {
                    e.preventDefault();
                    this.handleEventSave(1);
                });
                $('#btn-edit-events').on('click', (e) => {
                    e.preventDefault();
                    this.handleEventSave(2);
                });
                $('#btn-edit-all-events').on('click', (e) => {
                    e.preventDefault();
                    this.handleEventSave(3);
                });

                $('#btn-add-event').on('click', (e) => {
                    e.preventDefault();
                    this.handleEventSave();
                });

                $('#closeModalEvent').on('click', (e) => {
                    e.preventDefault();
                    this.closeModalEvent();
                });

                //OK
                $('#calendario').on('change', (e) => {
                    e.preventDefault();
                    $('#user-select').attr('disabled', true);
                    if (e.target.value === '0') {
                        $('#cliente').attr('disabled', true);
                        $('#cliente-select').val(0);
                        $('#commessa-select').attr('disabled', true);
                        $('#offerta-select').attr('disabled', true);
                        //$('#type').attr('disabled', true);
                    } else {
                        $('#cliente').attr('disabled', false);

                        $('.select2-selection__rendered').html('');
                        $('.sp_schedule_users_selection').prop('title', "La tipologia di calendario non consente la selezione individuale di utenti");
                        if ($('#calendario').hasClass('freeusers_' + e.target.value)) {
                            $('#user-select').attr('disabled', false);
                            $('.sp_schedule_users_selection').prop('title', "La tipologia di calendario consente di associare l'evento ad una lista di utenti a scelta");
                        }

                    }

                    const cliente = $('#cliente-select').val();
                    if (cliente > 0 && e.target.value > 0) {
                        $('#commessa-select').attr('disabled', false);
                        $('#offerta-select').attr('disabled', false);
                        //$('#type').attr('disabled', false);

                        const elements = this.serializeEvent();
                        const cliente = elements.cliente_select.val();
                        const commessa = elements.commessa_select.val();
                        const offerta = elements.offerta_select.val();
                        this.handleChangeCalendario(
                            e.target.value,
                            cliente,
                            commessa,
                            offerta
                        );
                    }
                });

                $('#cliente-select').on('change', (e) => {
                    e.preventDefault();
                    const elements = this.serializeEvent();

                    const idCalendar = elements.calendario.val();
                    if (idCalendar > 0) {
                        $('#commessa-select').attr('disabled', false);
                        $('#offerta-select').attr('disabled', false);
                        //$('#type').attr('disabled', false);
                    }
                    const commessa = elements.commessa_select.val();
                    const offerta = elements.offerta_select.val();
                    this.handleChangeClienteSelezionato(
                        idCalendar,
                        $(e.target).val(),
                        commessa,
                        offerta
                    );
                });

                $('#commessa-select').on('change', (e) => {
                    e.preventDefault();
                    const elements = this.serializeEvent();

                    const idCalendar = elements.calendario.val();
                    const cliente = elements.cliente_select.val();
                    const offerta = elements.offerta_select.val();
                    this.handleChangeCommessa(
                        idCalendar,
                        cliente,
                        $(e.target).val(),
                        offerta
                    );
                });

                $('#offerta-select').on('change', (e) => {
                    e.preventDefault();
                    const elements = this.serializeEvent();
                    const idCalendar = elements.calendario.val();
                    const cliente = elements.cliente_select.val();
                    const commessa = elements.commessa_select.val();
                    this.handleChangeOfferta(
                        idCalendar,
                        cliente,
                        commessa,
                        $(e.target).val()
                    );
                });

                $('#ripeti-evento').on('change', function (e) {
                    e.preventDefault();
                    if (this.checked) {
                        $('#row-container').collapse('show');
                        $('#has-recurrences').val('True');
                    } else {
                        $('#has-recurrences').val('False');
                        $('#row-container').collapse('hide');
                        $('#custom-recurrences').collapse('hide');
                        $('#units').val(0);
                        $('#time-unit-selector').prop('selectedIndex', 0);
                        $('#recurrence-frequency').prop('selectedIndex', 0);
                        $('#maxDateTimeTo').prop('disabled', true).val(null);
                        $('#maxItems').prop('disabled', true).val(0);
                        $('#number-recurrence, #date-recurrence').prop('checked', false);
                    }
                });

                $('#recurrence-frequency').on('change', function (e) {
                    e.preventDefault();
                    if (this.value == 5) {
                        // 5 -> option "Personalizza"
                        $('#custom-recurrences').collapse('show');
                    } else {
                        $('#custom-recurrences').collapse('hide');
                    }
                });

                $('#number-recurrence, #date-recurrence').on('change', function () {
                    if ($(this).attr('id') === 'number-recurrence') {
                        if ($(this).is(':checked')) {
                            // Se "number-recurrence" è attivato
                            $('#date-recurrence').prop('checked', false);
                            $('#maxDateTimeTo').prop('disabled', true).val(null);
                            $('#maxItems').prop('disabled', false);
                        } else {
                            $('#maxItems').prop('disabled', true).val(0);
                        }
                    } else if ($(this).attr('id') === 'date-recurrence') {
                        if ($(this).is(':checked')) {
                            $('#number-recurrence').prop('checked', false);
                            $('#maxItems').prop('disabled', true).val(0);
                            $('#maxDateTimeTo').prop('disabled', false);
                        } else {
                            $('#maxDateTimeTo').prop('disabled', true).val(null);
                        }
                    }
                });

                $('#complete').on('click', (e) => {
                    e.preventDefault();
                    if (confirm("L'operazione non può essere annullata, si vuole proseguire?")) { this.handleCompleteEvent(); }

                });

                $('#btn-undo-current').on('click', (e) => {
                    e.preventDefault();
                    if (confirm("L'operazione non può essere annullata, si vuole proseguire?")) { this.handleCancelEvent(1); }

                });
                $('#btn-undo-current-and-next').on('click', (e) => {
                    e.preventDefault();
                    if (confirm("L'operazione non può essere annullata, si vuole proseguire?")) { this.handleCancelEvent(2); }
                });
                $('#btn-undo-series').on('click', (e) => {
                    e.preventDefault();
                    if (confirm("L'operazione non può essere annullata, si vuole proseguire?")) { this.handleCancelEvent(3); }
                });

                $('#btn-delete-event').on('click', (e) => {
                    e.preventDefault();
                    if (confirm("L'operazione non può essere annullata, si vuole proseguire?")) { this.handleEventDelete(1); }
                });
                $('#btn-delete-events').on('click', (e) => {
                    e.preventDefault();
                    if (confirm("L'operazione non può essere annullata, si vuole proseguire?")) { this.handleEventDelete(2); }
                });
                $('#btn-delete-all-events').on('click', (e) => {
                    e.preventDefault();
                    if (confirm("L'operazione non può essere annullata, si vuole proseguire?")) { this.handleEventDelete(3); }
                });
                $('#tipologia-switch-calendario').on('change', function (e) {
                    e.preventDefault();
                    if (this.checked) {
                        $('#tipologia-nuovo-calendario').collapse('show');
                    } else {
                        $('#tipologia-nuovo-calendario').collapse('hide');
                    }
                });
                //handleChangeAssignableUsers();
                //loading.hide();


                $('#user-select').select2({
                    theme: 'bootstrap-5',
                    width: $(this).data('width')
                        ? $(this).data('width')
                        : $(this).hasClass('w-100')
                            ? '100%'
                            : 'style',
                    placeholder: $(this).data('placeholder'),
                    closeOnSelect: false,
                    templateResult: function (data, container) {
                        $(container).prop('disabled', false);
                        if ($(data.element).attr("data-is-active") === 'true') {
                            $(container).css("display", "block");
                        } else {
                            if ($(data.element).is(':selected')) {
                                $(container).css("display", "block");
                                $(container).prop('disabled', true);
                            } else {
                                $(container).css("display", "none");
                            }
                        }
                        return data.text;
                    }
                });
            }).catch((error) => {
                throw new Error(error);
            });
        } catch (e) {
            alert(`Ops! Qualcosa è andato storto.\n${e}`);
            
            //calendarComponentSpecificSpinner.classList.add('d-none');
        } finally {
            setTimeout(() => {
                //application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
                
            }, 700);
        }
    }


    handleTodayWidget() {
        if (this.airDatepicker) {
            const today = moment();
            this.airDatepicker.selectDate(today.format('YYYY-MM-DD'));
            this.airDatepicker.update();
        } 
    }

    setupCalendar() {
        this.calendar = new FullCalendar.Calendar(
            document.getElementById(this.calendarSelector),
            {
                themeSystem: 'bootstrap5',
                selectable: true,
                height: '100%',
                initialView: 'dayGridMonth',
                nowIndicator: true, // Mostra il giorno corrente
                locale: 'it',
                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'placeholder',
                },
                customButtons: { placeholder: { text: '' } },
                events: this.events,
                eventContent: (arg) => {
                    // Recupera l'icona dall'oggetto evento
                    let idPriority = arg.event.extendedProps.idPriority;
                    let title = arg.event.extendedProps.description;

                    let timeText = arg.timeText;
                    if (timeText.length == 2) { timeText = timeText + ':00' } //Correzione Lorenzo: visualizza orario HH:mm se orario HH

                    let icon = '';

                    let status = arg.event.extendedProps.idStato;
                    let event_class = '';
                    let hour_class = '';

                    if (status == 92) { event_class = "sp_underlined" };
                    if (status == 91) { hour_class = "sp_schedule_completed" };



                    if (idPriority == 1) {
                        icon = '<i class="bi bi-flag-fill text-white"></i>';// 'per mantenere lo spazio metto in bianco fittizio
                    } else if (idPriority == 2) {
                        icon = '<i class="bi bi-flag-fill" style="color: #eca740;"></i>';
                    } else if (idPriority == 3) {
                        icon = '<i class="bi bi-flag-fill text-danger"></i>';
                    } else {
                    }
                    //// Costruisce il contenuto dell'evento
                    let content = document.createElement('div');
                    content.innerHTML = `
                                <span class="ps-1 ${event_class}" title="${timeText} - ${title}">
                                <b><span class="event-time ${hour_class}"  >${timeText} | </span></b>
                                <span class="event-title" >${title}</span>
                                </span>
                                <b><span class="event-icon pl-1">${icon}</span></b>                             
                            `;


                    content.classList.add('d-flex', 'justify-content-between', 'w-100');
                    content.style.backgroundColor = "#fff";
                    content.style.borderLeft = "4px solid " + arg.event.extendedProps.backgroundColor;
                    content.style.textWrap = "auto";
                    return { domNodes: [content] };
                },
                eventMouseEnter: function (info) {
                    info.el.style.backgroundColor = '#ffff';
                },
                dateClick: (info) => {
                    const date = moment(info.date);
                    const start = date.format('YYYY-MM-DD');
                    const end = date.format('YYYY-MM-DD');
                    let timeStart, timeEnd;
                    if (info.view.type == 'dayGridMonth') {
                        timeStart = moment().format('HH:mm');
                        timeEnd = moment().add(1, 'hours').format('HH:mm');
                    } else {
                        timeStart = date.format('HH:mm');
                        timeEnd = date.add(1, 'hours').format('HH:mm');
                    }
                    $('#error').empty().addClass('d-none');
                    $('#idEvento').val('0');
                    $('#data_inizio').val(start);
                    $('#data_fine').val(end);
                    $('#ora_inizio').val(timeStart);
                    $('#ora_fine').val(timeEnd);

                    $('#maxDateTimeTo').attr('min', moment().format('YYYY-MM-DD'));
                    $('#units').val(0);
                    $('#maxItems').val(0);
                    $('#idOriginal').val(0);
                    $('#updateType').val(0);
                    $('#idStato').val(0);

                    $('#cliente').attr('disabled', true);
                    $('#commessa-select').attr('disabled', true);
                    $('#offerta-select').attr('disabled', true);
                    $('#nota').val('');
                    $('#nota').text('');
                    setTimeout(function () { $('#nota').removeClass('sp_autosize_worked'); }, 50);
                    setTimeout(function () { $('#nota').removeClass('sp_autosize_worked'); }, 5000);

                    //$('#type').attr('disabled', true);

                    $('#user-select').val(0);
                    $('#cliente').val('');

                    $('#btn-add-event').removeClass('d-none');
                    $('#eventModalLabel').text('Nuovo Evento');
                    $('#badgeEventCompletato').addClass('d-none');
                    $('#badgeEventAnnullato').addClass('d-none');
                    $('#badgeEventDaCompletare').addClass('d-none');

                    document.querySelectorAll('#creator_user option').forEach(option => {
                        option.style.display = '';
                        if (option.getAttribute('data-is-active') === 'false') {
                            if (option.selected) {
                                option.disabled = true
                            } else {
                                option.style.display = 'none'; // Nasconde l'opzione
                            }
                        } else {
                            option.style.display = ''; // Mostra l'opzione (se necessario)
                        }
                    });
                    document.querySelectorAll('#user_select option').forEach(option => {
                        if (option.getAttribute('data-is-active') === 'false') {
                            option.style.display = 'none'; // Nasconde l'opzione
                        } else {
                            option.style.display = ''; // Mostra l'opzione (se necessario)
                        }
                    });

                    //$('#eventModal').modal('show');
                    if (this.currentUserRights) {
                        if (this.currentUserRights.canAddEvent === true) {

                            application.ModalManagerIstance.show('eventModal');
                        }
                    }

                },
                eventClick: (info) => {
                    info.jsEvent.preventDefault();
                    this.handleEventClick(info.event.id, info.event.extendedProps.idCalendar);
                },
                datesSet: (dateInfo) => {
                    this.handleDatesSet(dateInfo);
                },
                viewDidMount: () => {
                    try {
                        this.calendar.updateSize();
                    } catch (error) {
                        
                    }
                },
                eventDidMount: function (info) {
                    info.el.style.borderLeft = "4px solid " + info.event.backgroundColor;
                    info.el.style.borderRadius = "0";
                },
            }
        );
        this.calendar.render();
        this.observeContainerResize();
        this.customButton();
    }

    observeContainerResize() {
        const mainContainer = document.getElementById('content');
        const resizeObserver = new ResizeObserver(() => {
            this.calendar.updateSize();
        });
        resizeObserver.observe(mainContainer);
    }

    customButton() {
        const customButton = document.querySelector('.fc-placeholder-button');
        if (customButton) {
            let addButton = document.createElement('button');
            addButton.className = 'btn btn-link me-3';
            addButton.setAttribute('id', 'btnEventModal');
            addButton.innerHTML = '<i class="bi bi-plus text-black fs-3"></i>';

            let selectElement = document.createElement('select');
            selectElement.id = 'view-selector';
            selectElement.className = 'form-select fc-select';
            selectElement.innerHTML = `
                      <option value="dayGridMonth">Mese</option>
                      <option value="timeGridWeek">Settimana</option>
                      <option value="timeGridDay">Giorno</option>`;

            let wrapperDiv = document.createElement('div');
            wrapperDiv.className = 'd-flex align-items-center';

            wrapperDiv.appendChild(addButton);
            wrapperDiv.appendChild(selectElement);

            customButton.parentNode.insertBefore(
                wrapperDiv,
                customButton.nextSibling
            );

            document
                .getElementById('view-selector')
                .addEventListener('change', (event) => {
                    const selectedView = event.target.value;
                    this.viewMode = selectedView;

                    if (
                        selectedView === 'timeGridDay' ||
                        selectedView === 'timeGridWeek'
                    ) {
                        this.isSyncing = false;
                        this.calendar.changeView(selectedView);
                    } else {
                        this.isSyncing = true;
                        this.calendar.changeView(selectedView);
                    }
                    this.calendar.updateSize();
                });
        }
    }

    setupCalendarView() {
        application.LoadingModalIstance.Build(
            'Attendere',
            'Caricamento dati in corso...'
        );
        const calendarComponentSpecificSpinner = document.getElementById(
            'sidebar-content-loader'
        );
        try {
            application.ModalManagerIstance.show(application.LoadingModalIstance.Id);
            calendarComponentSpecificSpinner.classList.remove('d-none');

            //const calendario = this.GetUserCalendars();
            //const priorita = this.GetEventPriorities();
            //const proprietario = this.GetUsers();
            //const utenti = this.GetAssignableUsers();
            //const timeUnits = this.GetTimeUnits();

            //Promise.all([calendario, priorita, proprietario, utenti, timeUnits])
            this.Setup(0, [], this.range[0], this.range[1]).then((response) => {

                const calendari = $('#calendario');
                const calendariListContainer = $('#sidebar-dropdown-menu');
                const priorita = $('#priority');
                const proprietario = $('#creator_user');
                const utenti = $('#user-select');
                const timeUnit = $('#time-unit-selector');
                const calendarBtnAdd = $('#calendar-btn-add');
                const calendarEventBtnAdd = $('#btnEventModal');

                //OK
                for (let i = 0; i < response.userCalendars.length; i++) {

                    if (!response.userCalendars[i].AllUsers && !response.userCalendars[i].IsPersonal) {
                        calendari.addClass('freeusers_' + response.userCalendars[i].Id);
                    }
                }


                this.currentUser = response.users.CurrentIdSelected;
                this.currentUserRights = response.rights;
                if (calendarEventBtnAdd) {
                    if (this.currentUserRights.canAddEvent === true) {
                        calendarEventBtnAdd.removeClass('d-none');
                    } else {
                        calendarEventBtnAdd.addClass('d-none');
                    }
                }

                if (calendarBtnAdd) {
                    if (this.currentUserRights.canAddCalendar === true) {
                        calendarBtnAdd.removeClass('d-none');
                    } else {
                        calendarBtnAdd.addClass('d-none');
                    }
                }
                if (calendari) {
                    this.renderSelectDropdown(
                        calendari,
                        response.userCalendars,
                        'Title',
                        'Id',
                        true,
                        0
                    );
                }
                if (calendariListContainer) {
                    
                    this.renderCalendarList(
                        calendariListContainer,
                        response.userCalendars,
                        'Title',
                        'Id',
                        true,
                        0
                    );
                }

                calendarComponentSpecificSpinner.classList.add('d-none');

                if (priorita) {
                    this.renderSelectDropdown(
                        priorita,
                        response.eventPriorities.Items,
                        'Description',
                        'Id',
                        response.eventPriorities.CanEdit,
                        response.eventPriorities.CurrentIdSelected
                    );
                }

                if (proprietario) {
                    this.renderSelectDropdown(
                        proprietario,
                        response.users.Items,
                        'Description',
                        'Id',
                        response.users.CanEdit,
                        response.users.CurrentIdSelected
                    );
                }

                if (utenti) {
                    this.renderSelectDropdown(
                        utenti,
                        response.assignableUsers.Items,
                        'Description',
                        'Id',
                        response.assignableUsers.CanEdit,
                        response.assignableUsers.CurrentIdSelected
                    );
                }

                if (timeUnit) {
                    this.renderSelectDropdown(
                        timeUnit,
                        response.timeUnits.Items,
                        'Description',
                        'Id',
                        true,
                        0
                    );
                }

                calendarEventBtnAdd.on('click', (e) => {
                    e.preventDefault();
                    let currentDay = moment().add(1, 'days').format('YYYY-MM-DD');
                    let start = moment().format('HH:mm');
                    let end = moment().add(1, 'hours').format('HH:mm');

                    $('#data_inizio').val(currentDay);
                    $('#data_fine').val(currentDay);
                    $('#ora_inizio').val(start);
                    $('#ora_fine').val(end);

                    $('#data_inizio').attr('min', moment().format('YYYY-MM-DD'));
                    $('#data_fine').attr('min', moment().format('YYYY-MM-DD'));

                    $('#maxDateTimeTo').attr('min', moment().format('YYYY-MM-DD'));
                    $('#units').val(0);
                    $('#maxItems').val(0);
                    $('#idOriginal').val(0);
                    $('#updateType').val(0);
                    $('#idStato').val(0);

                    $('#cliente').attr('disabled', true);
                    $('#commessa-select').attr('disabled', true);
                    $('#offerta-select').attr('disabled', true);
                    $('#nota').val('');
                    $('#nota').text('');
                    setTimeout(function () { $('#nota').removeClass('sp_autosize_worked'); }, 50);
                    setTimeout(function () { $('#nota').removeClass('sp_autosize_worked'); }, 5000);

                    //$('#type').attr('disabled', true);

                    $('#user-select').val(0);
                    $('#cliente').val('');

                    $('#btn-add-event').removeClass('d-none');
                    $('#eventModalLabel').text('Nuovo Evento');
                    $('#badgeEventCompletato').addClass('d-none');
                    $('#badgeEventAnnullato').addClass('d-none');
                    $('#badgeEventDaCompletare').addClass('d-none');
                    //$('#eventModal').modal('show');
                    document.querySelectorAll('#creator_user option').forEach(option => {
                        option.style.display = '';
                        if (option.getAttribute('data-is-active') === 'false') {
                            if (option.selected) {
                                option.disabled = true
                            } else {
                                option.style.display = 'none'; // Nasconde l'opzione
                            }
                        } else {
                            option.style.display = ''; // Mostra l'opzione (se necessario)
                        }
                    });
                    document.querySelectorAll('#user_select option').forEach(option => {
                        if (option.getAttribute('data-is-active') === 'false') {
                            option.style.display = 'none'; // Nasconde l'opzione
                        } else {
                            option.style.display = ''; // Mostra l'opzione (se necessario)
                        }
                    });
                    application.ModalManagerIstance.show('eventModal');
                });

                $('#btn-edit-event').on('click', (e) => {
                    e.preventDefault();
                    this.handleEventSave(1);
                });
                $('#btn-edit-events').on('click', (e) => {
                    e.preventDefault();
                    this.handleEventSave(2);
                });
                $('#btn-edit-all-events').on('click', (e) => {
                    e.preventDefault();
                    this.handleEventSave(3);
                });

                $('#btn-add-event').on('click', (e) => {
                    e.preventDefault();
                    this.handleEventSave();
                });

                $('#closeModalEvent').on('click', (e) => {
                    e.preventDefault();
                    this.closeModalEvent();
                });

                // NOn funziona?
                $('#calendario').on('change', (e) => {
                    e.preventDefault();
                    $('#user-select').attr('disabled', true);
                    if (e.target.value === '0') {
                        $('#cliente').attr('disabled', true);
                        $('#cliente-select').val(0);
                        $('#commessa-select').attr('disabled', true);
                        $('#offerta-select').attr('disabled', true);
                        //$('#type').attr('disabled', true);
                    } else {
                        $('#cliente').attr('disabled', false);

                        $('.select2-selection__rendered').html('');
                        $('.sp_schedule_users_selection').prop('title', "La tipologia di calendario non consente la selezione individuale di utenti");
                        if ($('#calendario').hasClass('freeusers_' + e.target.value)) {
                            $('#user-select').attr('disabled', false);
                            $('.sp_schedule_users_selection').prop('title', "La tipologia di calendario consente di associare l'evento ad una lista di utenti a scelta");
                        }

                    }

                    const cliente = $('#cliente-select').val();
                    if (cliente > 0 && e.target.value > 0) {
                        $('#commessa-select').attr('disabled', false);
                        $('#offerta-select').attr('disabled', false);
                        //$('#type').attr('disabled', false);

                        const elements = this.serializeEvent();
                        const cliente = elements.cliente_select.val();
                        const commessa = elements.commessa_select.val();
                        const offerta = elements.offerta_select.val();
                        this.handleChangeCalendario(
                            e.target.value,
                            cliente,
                            commessa,
                            offerta
                        );
                    }
                });


                $('#cliente-select').on('change', (e) => {
                    e.preventDefault();
                    const elements = this.serializeEvent();

                    const idCalendar = elements.calendario.val();
                    if (idCalendar > 0) {
                        $('#commessa-select').attr('disabled', false);
                        $('#offerta-select').attr('disabled', false);
                        //$('#type').attr('disabled', false);
                    }
                    const commessa = elements.commessa_select.val();
                    const offerta = elements.offerta_select.val();
                    this.handleChangeClienteSelezionato(
                        idCalendar,
                        $(e.target).val(),
                        commessa,
                        offerta
                    );
                });

                $('#commessa-select').on('change', (e) => {
                    e.preventDefault();
                    const elements = this.serializeEvent();

                    const idCalendar = elements.calendario.val();
                    const cliente = elements.cliente_select.val();
                    const offerta = elements.offerta_select.val();
                    this.handleChangeCommessa(
                        idCalendar,
                        cliente,
                        $(e.target).val(),
                        offerta
                    );
                });

                $('#offerta-select').on('change', (e) => {
                    e.preventDefault();
                    const elements = this.serializeEvent();
                    const idCalendar = elements.calendario.val();
                    const cliente = elements.cliente_select.val();
                    const commessa = elements.commessa_select.val();
                    this.handleChangeOfferta(
                        idCalendar,
                        cliente,
                        commessa,
                        $(e.target).val()
                    );
                });

                $('#ripeti-evento').on('change', function (e) {
                    e.preventDefault();
                    if (this.checked) {
                        $('#row-container').collapse('show');
                        $('#has-recurrences').val('True');
                    } else {
                        $('#has-recurrences').val('False');
                        $('#row-container').collapse('hide');
                        $('#custom-recurrences').collapse('hide');
                        $('#units').val(0);
                        $('#time-unit-selector').prop('selectedIndex', 0);
                        $('#recurrence-frequency').prop('selectedIndex', 0);
                        $('#maxDateTimeTo').prop('disabled', true).val(null);
                        $('#maxItems').prop('disabled', true).val(0);
                        $('#number-recurrence, #date-recurrence').prop('checked', false);
                    }
                });

                $('#recurrence-frequency').on('change', function (e) {
                    e.preventDefault();
                    if (this.value == 5) {
                        // 5 -> option "Personalizza"
                        $('#custom-recurrences').collapse('show');
                    } else {
                        $('#custom-recurrences').collapse('hide');
                    }
                });

                $('#number-recurrence, #date-recurrence').on('change', function () {
                    if ($(this).attr('id') === 'number-recurrence') {
                        if ($(this).is(':checked')) {
                            // Se "number-recurrence" è attivato
                            $('#date-recurrence').prop('checked', false);
                            $('#maxDateTimeTo').prop('disabled', true).val(null);
                            $('#maxItems').prop('disabled', false);
                        } else {
                            $('#maxItems').prop('disabled', true).val(0);
                        }
                    } else if ($(this).attr('id') === 'date-recurrence') {
                        if ($(this).is(':checked')) {
                            $('#number-recurrence').prop('checked', false);
                            $('#maxItems').prop('disabled', true).val(0);
                            $('#maxDateTimeTo').prop('disabled', false);
                        } else {
                            $('#maxDateTimeTo').prop('disabled', true).val(null);
                        }
                    }
                });

                $('#complete').on('click', (e) => {
                    e.preventDefault();
                    this.handleCompleteEvent();
                });

                $('#btn-undo-current').on('click', (e) => {
                    e.preventDefault();
                    this.handleCancelEvent(1);
                });
                $('#btn-undo-current-and-next').on('click', (e) => {
                    e.preventDefault();
                    this.handleCancelEvent(2);
                });
                $('#btn-undo-series').on('click', (e) => {
                    e.preventDefault();
                    this.handleCancelEvent(3);
                });

                $('#btn-delete-event').on('click', (e) => {
                    e.preventDefault();
                    this.handleEventDelete(1);
                });
                $('#btn-delete-events').on('click', (e) => {
                    e.preventDefault();
                    this.handleEventDelete(2);
                });
                $('#btn-delete-all-events').on('click', (e) => {
                    e.preventDefault();
                    this.handleEventDelete(3);
                });
                $('#tipologia-switch-calendario').on('change', function (e) {
                    e.preventDefault();
                    if (this.checked) {
                        $('#tipologia-nuovo-calendario').collapse('show');
                    } else {
                        $('#tipologia-nuovo-calendario').collapse('hide');
                    }
                });
                //handleChangeAssignableUsers();
                //loading.hide();


                $('#user-select').select2({
                    theme: 'bootstrap-5',
                    width: $(this).data('width')
                        ? $(this).data('width')
                        : $(this).hasClass('w-100')
                            ? '100%'
                            : 'style',
                    placeholder: $(this).data('placeholder'),
                    closeOnSelect: false,
                    templateResult: function (data, container) {
                        $(container).prop('disabled', false);
                        if ($(data.element).attr("data-is-active") === 'true') {
                            $(container).css("display", "block");
                        } else {
                            if ($(data.element).is(':selected')) {
                                $(container).css("display", "block");
                                $(container).prop('disabled', true);
                            } else {
                                $(container).css("display", "none");
                            }
                        }
                        return data.text;
                    }
                });
            })
                .catch((error) => {
                    throw new Error(error);
                });
        } catch (e) {
            alert(`Ops! Qualcosa è andato storto.\n${e}`);
            
            calendarComponentSpecificSpinner.classList.add('d-none');
        } finally {
            setTimeout(() => {
                application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
                
            }, 700);
        }
    }
    /** */
    openModalEvent(
        mode = 'new',
        recurringEvent = false,
        canEdit = false,
        idStato = 90
    ) {

        $('#error').empty().addClass('d-none');
        $('#status-evento-container').addClass('d-none');
        if (mode === 'edit') {
            
            $('#eventModalLabel').text('Modifica Evento');
            $('#calendario').prop('disabled', true);

            $('#badgeEventCompletato').addClass('d-none');
            $('#badgeEventAnnullato').addClass('d-none');
            $('#badgeEventDaCompletare').addClass('d-none');

            if (idStato == 91) {
                //Evento completato
                $('#badgeEventCompletato').removeClass('d-none');
            } else if (idStato == 92) {
                //Evento annullato
                $('#badgeEventAnnullato').removeClass('d-none');
            } else if (idStato == 90) {
                //Evento da completare
                $('#badgeEventDaCompletare').removeClass('d-none');
            }


            if (canEdit == false) {
                $('#status-evento-container')
                    .removeClass('d-none')
                    .addClass('alert-dark')
                    .text("L'evento non è modificabile");
            } else {

                $('#btn-edit-event').removeClass('d-none');
                $('#btn-delete-event').removeClass('d-none');
                $('#btn-undo-current').removeClass('d-none');

                $('#maxDateTimeTo').attr('min', moment().format('YYYY-MM-DD'));

                $('#delete-series').removeClass('d-none');
                $('#undo-series').removeClass('d-none');
                $('#save-series').removeClass('d-none');


                $('#complete').removeClass('d-none');

                if (recurringEvent) {

                    $('#btn-undo-current-and-next').removeClass('d-none');
                    $('#btn-undo-series').removeClass('d-none');

                    $('#btn-delete-events').removeClass('d-none');
                    $('#btn-delete-all-events').removeClass('d-none');

                    $('#btn-edit-events').removeClass('d-none');
                    $('#btn-edit-all-events').removeClass('d-none');
                }
            }

            document.querySelectorAll('#user-select option').forEach(option => {
                if (option.getAttribute('data-is-active') === 'false') {
                    if (option.selected) {
                        
                        option.style.display = '';
                        option.setAttribute('disabled', true);
                    } else {
                        option.style.display = 'none';
                    }
                } else {
                    option.removeAttribute('disabled');
                    option.style.display = ''; // Mostra l'opzione (se necessario)
                }
            });

            $('#calendario').trigger('change');

            $("#user-select").trigger('change.select2');
            $('#cliente').attr('disabled', true);
            $('#commessa-select').attr('disabled', true);
            $('#offerta-select').attr('disabled', true);

            application.ModalManagerIstance.show('eventModal');
            //$('#eventModal').modal('show');
        } else {
            let currentDay = moment().add(1, 'days').format('DD/MM/YYYY');
            let start = moment().format('HH:mm');
            let end = moment().add(1, 'hours').format('HH:mm');
            $('#status-evento-container').addClass('d-none');
            $('#maxDateTimeTo').attr('min', moment().format('YYYY-MM-DD'));
            $('#data_inizio').attr('min', moment().format('YYYY-MM-DD'));
            $('#data_fine').attr('min', moment().format('YYYY-MM-DD'));
            $('#idEvento').val('0');
            $('#data_inizio').val(currentDay);
            $('#data_fine').val(currentDay);
            $('#ora_inizio').val(start);
            $('#ora_fine').val(end);
            $('#btn-add-event').removeClass('d-none');
            $('#eventModalLabel').text('Nuovo Evento');
            $('#badgeEventCompletato').addClass('d-none');
            $('#badgeEventAnnullato').addClass('d-none');
            $('#badgeEventDaCompletare').addClass('d-none');
            $('#cliente').attr('disabled', false);
            $('#nota').val('');
            $('#nota').text('');
            setTimeout(function () { $('#nota').removeClass('sp_autosize_worked'); }, 50);
            setTimeout(function () { $('#nota').removeClass('sp_autosize_worked'); }, 5000);

            $('#commessa-select').attr('disabled', false);
            $('#offerta-select').attr('disabled', false);


            document.querySelectorAll('#creator_user option').forEach(option => {
                option.style.display = '';
                if (option.getAttribute('data-is-active') === 'false') {
                    if (option.selected) {
                        option.disabled = true
                    } else {
                        option.style.display = 'none'; // Nasconde l'opzione
                    }
                } else {
                    option.style.display = ''; // Mostra l'opzione (se necessario)
                }
            });
            document.querySelectorAll('#user_select option').forEach(option => {
                if (option.getAttribute('data-is-active') === 'false') {
                    option.style.display = 'none'; // Nasconde l'opzione
                } else {
                    option.style.display = ''; // Mostra l'opzione (se necessario)
                }
            });

            application.ModalManagerIstance.show('eventModal');
        }
    }

    closeModalEvent() {
        const elements = this.serializeEvent();

        if (this.airDatepicker || this.calendar) {
            $('#cliente').val('');
            $('#cliente-select').val('0');
            for (let key in elements) {
                if (elements.hasOwnProperty(key)) {
                    const element = elements[key];
                    if (key === 'creator_user') {
                        element.val(this.currentUser);
                    } else {
                        switch (element.prop('tagName')) {
                            case 'INPUT':
                                element.val('');
                                break;
                            case 'SELECT':
                                element.val(0);
                                break;
                            default:
                                break;
                        }
                    }
                }
            }
        }
        $('#error').empty().addClass('d-none');

        $('#calendario').prop('disabled', false);
        $('#status-evento-container').addClass('d-none');
        $('#idEvento').val(0);
        $('#units').val(0);
        $('#maxItems').val(0);
        $('#priority').val(1);
        $('#idOriginal').val(0);
        $('#updateType').val(0);
        $('#ripeti-evento').prop('checked', false);
        $('#row-container').collapse('hide');
        $('#custom-recurrences').collapse('hide');
        $('#time-unit-selector').prop('selectedIndex', 0);
        $('#recurrence-frequency').prop('selectedIndex', 0);
        $('#maxDateTimeTo').prop('disabled', true).val(null);
        $('#after').prop('disabled', true).val(0);
        $('#number-recurrence, #date-recurrence').prop('checked', false);

        $('#cliente').attr('disabled', false);
        $('#commessa-select').attr('disabled', false);
        $('#offerta-select').attr('disabled', false);
        //$('#type').attr('disabled', false);

        $('#user-select').val(0).trigger('change');

        $('#btn-add-event').addClass('d-none');

        $('#undo-series').addClass('d-none');
        $('#btn-undo-current').addClass('d-none');
        $('#btn-undo-current-and-next').addClass('d-none');
        $('#btn-undo-series').addClass('d-none');

        $('#save-series').addClass('d-none');
        $('#btn-edit-event').addClass('d-none');
        $('#btn-edit-events').addClass('d-none');
        $('#btn-edit-all-events').addClass('d-none');

        $('#delete-series').addClass('d-none');
        $('#btn-delete-event').addClass('d-none');
        $('#btn-delete-events').addClass('d-none');
        $('#btn-delete-all-events').addClass('d-none');

        $('#complete').addClass('d-none');

        $('#eventModalLabel').empty();


        application.ModalManagerIstance.hide('eventModal');

    }

    openModalNewCalendario(id, name, predefinedIdType, color, IsPersonal , AllUsers) {
        try {
            this.GetScheduleTypes()
                .then((response) => {
                    if (response.IsSuccess) {
                        this.renderSelectDropdown(
                            $('#calendarType'),
                            response.Data.Items,
                            'Description',
                            'Id',
                            response.CanEdit,
                            predefinedIdType
                        );

                        $('#calendarName').val(name);
                        $('#calendarColor').val(color);
                        $('#tipologia-switch-calendario').prop('checked', false);
                        $('#tipologia-nuovo-calendario').collapse('hide');
                        $('#calendarType').val(predefinedIdType || '0');
                        $('#idCalendar').val(id);

                        $('#calendario-div-all-users').removeClass('d-none');
                        if (IsPersonal) { $('#calendario-div-all-users').addClass('d-none'); }


                        application.ModalManagerIstance.show('createCalendarModal');
                        //$('#createCalendarModal').modal('show');
                        if (id > 0) {
                            $('#createCalendarModalLabel').text('Modifica calendario');
                            $('#chkAllUsers').prop("checked", AllUsers);
                        } else {
                            $('#createCalendarModalLabel').text('Crea nuovo calendario');
                            $('#chkAllUsers').prop("checked", false);

                        }
                    } else {
                        throw new Error(response.Message);
                    }
                })
                .catch((error) => {
                    
                });
        } catch (e) {
            
        }
    }

    closeModalNewCalendario() {
        $('#idCalendar').val('0');

        const title = $('#calendarName');
        title.val('0');

        const predefinedIdScheduleType = $('#calendarType');
        predefinedIdScheduleType.val('0');

        const calendarColor = $('#calendarColor');
        calendarColor.val('#ff0000');
        $('#chkAllUsers').prop("checked", false);

        //$('#createCalendarModal').modal('hide');
        application.ModalManagerIstance.hide('createCalendarModal');

    }

    async handleSaveCalendar() {
        try {
            const id = $('#idCalendar');
            const title = $('#calendarName');
            const lblTitleError = $(`label.error[for="calendarName"]`);
            const predefinedIdScheduleType = $('#calendarType');
            const lblCalendarTypeError = $(`label.error[for="calendarType"]`);
            const calendarColor = $('#calendarColor');
            const lblCalendarColorError = $(`label.error[for="calendarColor"]`);
            const calendarAllUsers = $('#chkAllUsers');

            const response = await this.SaveCalendarDetail(
                id.val(),
                title.val(),
                predefinedIdScheduleType.val(),
                calendarColor.val(),
                calendarAllUsers.prop('checked')
            );
            if (response.IsSuccess) {
                application.ModalManagerIstance.hide('createCalendarModal');
                //$('#createCalendarModal').modal('hide');
                await this.delay();
                application.SystemGenericModalIstance.Build(
                    'Salvataggio completato',
                    'I dati sono stati salvati correttamente.',
                    'success',
                    3000,
                    false,
                    '',
                    null,
                    false,
                    '',
                    null,
                    true,
                    'OK',
                    () => {  }
                );
                application.ModalManagerIstance.show(
                    application.SystemGenericModalIstance.Id
                );

               
                window.location = window.location.href;

            } else {
                throw new Error(response.Message);
            }
        } catch (e) {
            application.ModalManagerIstance.hide('createCalendarModal');
            //$('#createCalendarModal').modal('hide');
            await this.delay();
            application.SystemGenericModalIstance.Build(
                'Ops! qualcosa è andato storto.',
                e,
                'danger',
                15000,
                false,
                '',
                null,
                false,
                '',
                null,
                true,
                'OK',
                () => { }
            );
            application.ModalManagerIstance.show(
                application.SystemGenericModalIstance.Id
            );
            
        }
    }

    async handleEventClick(id, idCalendar) {
        application.LoadingModalIstance.Build(
            'Attendere',
            'Caricamento dati in corso...'
        );
        application.ModalManagerIstance.show(application.LoadingModalIstance.Id);
        await this.delay();
        try {
            if (!id) {
                throw new Error('Id scadenza non valido.');
            }
            if (!idCalendar) {
                throw new Error('Id calendario non valido.');
            }

            const responseEvent = await this.GetEventDetail(
                idCalendar,
                id
            );
            if (!responseEvent.IsSuccess) {
                throw new Error(`${responseEvent.Message}`);
            }
            const eventDetail = responseEvent.Data;

            const responses = await Promise.all([
                this.GetAssignableUsers(),
                this.GetScheduleTypesByCalendar(
                    eventDetail.IdCalendar,
                    eventDetail.IdCliente,
                    eventDetail.IdCommessa,
                    eventDetail.IdOfferta
                ),
                this.GetCustomerInfos(eventDetail.IdCliente),
            ]);

            const $selectElement = $('#user-select');
            const tipologia = $('#type');
            const commesse = $('#commessa-select');
            const offerte = $('#offerta-select');

            if (!responses[0].IsSuccess) {
                throw new Error(`${responses[0].Message}`);
            }
            if (!responses[1].IsSuccess) {
                throw new Error(`${responses[1].Message}`);
            }
            if (!responses[2].IsSuccess) {
                throw new Error(`${responses[1].Message}`);
            }

            this.renderSelectDropdown(
                $selectElement,
                responses[0].Data.Items,
                'Description',
                'Id',
                responses[0].Data.CanEdit,
                responses[0].Data.CurrentIdSelect
            );
            this.renderSelectDropdown(
                tipologia,
                responses[1].Data.Items,
                'Description',
                'Id',
                responses[1].Data.CanEdit,
                responses[1].Data.CurrentIdSelected
            );
            
            this.renderSelectDropdown(
                commesse,
                responses[2].Data.Commesse.Items,
                'Description',
                'Id',
                true,
                eventDetail.IdCommessa
            );
            this.renderSelectDropdown(
                offerte,
                responses[2].Data.Offerte.Items,
                'Description',
                'Id',
                true,
                eventDetail.IdOfferta
            );

            try {
                var startDate = moment(eventDetail.Start);
                var endDate = moment(eventDetail.End);
                var maxDateTimeTo =
                    eventDetail.MaxDateTimeTo === '1900-01-01T00:00:00'
                        ? null
                        : moment(eventDetail.MaxDateTimeTo).format('YYYY-MM-DD');
                var startDateString = startDate.format('YYYY-MM-DD');
                var endDateString = endDate.format('YYYY-MM-DD');
                var startTimeString = startDate.format('HH:mm');
                var endTimeString = endDate.format('HH:mm');

                const formData = this.serializeEvent();

                formData.id.val(eventDetail.Id);
                formData.data_inizio.val(startDateString);
                formData.data_fine.val(endDateString);
                formData.ora_inizio.val(startTimeString);
                formData.ora_fine.val(endTimeString);

                formData.titolo.val(eventDetail.Title);
                formData.calendario.val(eventDetail.IdCalendar);
                formData.all_day.prop('checked', eventDetail.AllDay);

                formData.timeUnit.val(
                    eventDetail.IdTimeUnit == -1 ? 0 : eventDetail.IdTimeUnit
                );
                formData.units.val(eventDetail.Units == -1 ? 0 : eventDetail.Units);
                formData.maxDateTimeTo.val(maxDateTimeTo);

                formData.maxItems.val(
                    eventDetail.MaxItems == -1 ? 0 : eventDetail.MaxItems
                );

                formData.idOriginal.val(
                    eventDetail.IdOriginal == -1 ? 0 : eventDetail.IdOriginal
                );
                formData.updateType.val(
                    eventDetail.UpdateType == -1 ? 0 : eventDetail.UpdateType
                );
                formData.idStato.val(eventDetail.IdStato);

                formData.creator_user.val(eventDetail.IdUtente);
                formData.type.val(eventDetail.IdScheduleType);
                formData.priority.val(eventDetail.IdPriority);

                formData.utenti_selezionati
                    .val(eventDetail.IdUtentiInvitati)
                    .trigger('change');


                formData.cliente_select.val(eventDetail.IdCliente);
                formData.commessa_select.val(eventDetail.IdCommessa);
                formData.offerta_select.val(eventDetail.IdOfferta);
                formData.nota.val(eventDetail.Note);
                formData.nota.text(eventDetail.Note);
                setTimeout(function () { formData.nota.removeClass('sp_autosize_worked'); }, 50);
                setTimeout(function () { formData.nota.removeClass('sp_autosize_worked'); }, 5000);

                const userSelect = $('#user-select option');
                this.usersSelected(userSelect);
                tipologia.attr('disabled', false);
                $('#cliente').val(eventDetail.DescriptionCliente);
                if (eventDetail.IdOriginal > 0) {
                    $('#ripeti-evento').prop('checked', true);
                    $('#has-recurrences').val('True');
                    $('#row-container').collapse('show');
                    $('#custom-recurrences').collapse('show');
                    $('#recurrence-frequency').val(5); //--imposto custom anche se hanno selezionato una predefined perchè non è salvata su db la scelta
                    if (eventDetail.MaxItems > 0) {
                        $('#number-recurrence').prop('checked', true);
                        $('#number-recurrence').trigger('change');
                    } else {
                        $('#date-recurrence').prop('checked', true);
                        $('#date-recurrence').trigger('change');
                    }
                } else {
                    $('#ripeti-evento').prop('checked', false);
                    $('#has-recurrences').val('False');
                    $('#row-container').collapse('hide');
                }

                setTimeout(() => {
                    application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
                }, 700);
                await this.delay();
                this.openModalEvent(
                    'edit',
                    eventDetail.IdOriginal > 0 ? true : false,
                    eventDetail.CanEdit,
                    eventDetail.IdStato
                );
            } catch (error) {
                throw new Error(`Errore impostazione campi\n${error}`);
            }
        } catch (error) {
            setTimeout(() => {
                application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
            }, 700);
            await this.delay();
            

            application.SystemGenericModalIstance.Build(
                'Ops! qualcosa è andato storto.',
                error,
                'danger',
                15000,
                false,
                '',
                null,
                false,
                '',
                null,
                true,
                'OK',
                () => { }
            );
            application.ModalManagerIstance.show(
                application.SystemGenericModalIstance.Id
            );
        }
    }
    handleChangeCliente(searchKey) {
        //ricerca solo con almeno 3 caratteri digitati
        if (searchKey.length >= 3) {
            if (handleGlobalTypingSearchController) {
                handleGlobalTypingSearchController.abort();
            }
            handleGlobalTypingSearchController = new AbortController();
            debounce(
                handleGlobalSearch(searchKey, true, false, false, -1)
                    .then((response) => {
                        if (response) {
                            this.showSuggestions(
                                response.Data.Clienti,
                                'clienti-autocomplte',
                                'cliente',
                                'cliente-select'
                            );
                        }
                    })
                    .catch((errore) => {
                        
                        if (errore.name === 'AbortError') {
                            //abort comandato da debounce;
                        } 
                    }),
                300
            );
        }
    }

    handleSelectedCliente() {
        try {
            const id = $('#cliente-select').val();
            if (!id) {
                throw new Error(`Errore lettura ID anagrafica: ${id}`);
            }
            this.GetCustomerInfos(id)
                .then((response) => {
                    if (response.IsSuccess) {
                        const Commesse = response.Data.Commesse;
                        const Offerte = response.Data.Offerte;

                        this.renderSelectDropdown(
                            $('#commessa-select'),
                            Commesse.Items,
                            'Description',
                            'Id',
                            Commesse.CanEdit,
                            0,
                            Commesse.CurrentIdSelected
                        );

                        this.renderSelectDropdown(
                            $('#offerta-select'),
                            Offerte.Items,
                            'Description',
                            'Id',
                            Offerte.CanEdit,
                            0,
                            Offerte.CurrentIdSelected
                        );
                    } else {
                        throw new Error(`Risposta: `, response);
                    }
                })
                .catch((error) => {
                    throw new Error(`Richiesta di rete`, error);
                });
        } catch (e) {
            
        }
    }

    async commesseByUtente() {

    }

    async handleChangeCalendario(idCalendar, cliente, commessa, offerta) {
        application.LoadingModalIstance.Build(
            'Attendere',
            'Caricamento dati in corso...'
        );
        try {
            const tipologia = await this.GetScheduleTypesByCalendar(
                idCalendar,
                cliente,
                commessa,
                offerta
            );
            if (tipologia.IsSuccess) {
                this.renderSelectDropdown(
                    $('#type'),
                    tipologia.Data.Items,
                    'Description',
                    'Id'
                );
            } else {
                throw new Error(`${tipologia.Message}`);
            }
        } catch (e) {
            application.SystemGenericModalIstance.Build(
                'Ops! qualcosa è andato storto.',
                e,
                'danger',
                15000,
                false,
                '',
                null,
                false,
                '',
                null,
                true,
                'OK',
                null
            );
            application.ModalManagerIstance.show(
                application.SystemGenericModalIstance.Id
            );

            
        }
    }

    async handleChangeClienteSelezionato(idCalendar, cliente, commessa, offerta) {
        application.LoadingModalIstance.Build(
            'Attendere',
            'Caricamento dati in corso...'
        );
        try {
            const tipologia = await this.GetScheduleTypesByCalendar(
                idCalendar,
                cliente,
                commessa,
                offerta
            );
            if (tipologia.IsSuccess) {
                this.renderSelectDropdown(
                    $('#type'),
                    tipologia.Data.Items,
                    'Description',
                    'Id'
                );
                //$('#type').attr('disabled', false);
                $('#commessa-select').attr('disabled', false);
                $('#offerta-select').attr('disabled', false);
            } else {
                throw new Error(`${tipologia.Message}`);
            }
        } catch (e) {
            application.SystemGenericModalIstance.Build(
                'Ops! qualcosa è andato storto.',
                e,
                'danger',
                15000,
                false,
                '',
                null,
                false,
                '',
                null,
                true,
                'OK',
                null
            );
            application.ModalManagerIstance.show(
                application.SystemGenericModalIstance.Id
            );

            
        }
    }

    async handleChangeCommessa(idCalendar, cliente, commessa, offerta) {
        application.LoadingModalIstance.Build(
            'Attendere',
            'Caricamento dati in corso...'
        );
        try {
            if (commessa === '0') {
                $('#offerta-select').attr('disabled', false);
            } else {
                $('#offerta-select').attr('disabled', true);
                const tipologia = await this.GetScheduleTypesByCalendar(
                    idCalendar,
                    cliente,
                    commessa,
                    offerta
                );
                if (tipologia.IsSuccess) {
                    this.renderSelectDropdown(
                        $('#type'),
                        tipologia.Data.Items,
                        'Description',
                        'Id'
                    );
                } else {
                    throw new Error(`${tipologia.Message}`);
                }
            }
        } catch (e) {
            application.SystemGenericModalIstance.Build(
                'Ops! qualcosa è andato storto.',
                e,
                'danger',
                15000,
                false,
                '',
                null,
                false,
                '',
                null,
                true,
                'OK',
                () => { }
            );
            application.ModalManagerIstance.show(
                application.SystemGenericModalIstance.Id
            );
            
        }
    }

    async handleChangeOfferta(idCalendar, cliente, commessa, offerta) {
        application.LoadingModalIstance.Build(
            'Attendere',
            'Caricamento dati in corso...'
        );
        try {
            if (offerta === '0') {
                $('#commessa-select').attr('disabled', false);
            } else {
                $('#commessa-select').attr('disabled', true);
                const tipologia = await this.GetScheduleTypesByCalendar(
                    idCalendar,
                    cliente,
                    commessa,
                    offerta
                );
                if (tipologia.IsSuccess) {
                    this.renderSelectDropdown(
                        $('#type'),
                        tipologia.Data.Items,
                        'Description',
                        'Id'
                    );
                } else {
                    throw new Error(`${tipologia.Message}`);
                }
            }
        } catch (e) {
            application.SystemGenericModalIstance.Build(
                'Ops! qualcosa è andato storto.',
                e,
                'danger',
                15000,
                false,
                '',
                null,
                false,
                '',
                null,
                true,
                'OK',
                () => { }
            );
            application.ModalManagerIstance.show(
                application.SystemGenericModalIstance.Id
            );
            
        }
    }

    async handleEventSave(updateType) {
        application.LoadingModalIstance.Build(
            'Attendere',
            'Invio dati in corso...'
        );
        const modalEvent = $('#eventModal');
        try {
            const elements = this.serializeEvent();
            const event = {
                Id: elements.id.val() || '0',
                IdCalendar: elements.calendario.val(),
                IdCommessa: elements.commessa_select.val() || '0',
                IdOfferta: elements.offerta_select.val() || '0',
                IdCliente: elements.cliente_select.val() || '0',
                IdUtente: elements.creator_user.val(),
                IdUtentiInvitati: elements.utenti_selezionati.val(),
                IdPriority: elements.priority.val() || '0',
                IdExternal: '0',
                IdExternalProfile: '0',
                IdScheduleType: elements.type.val(),
                GroupId: elements.calendario.val(),
                Title: elements.titolo.val(),
                Note: elements.nota.val(),
                Start: `${elements.data_inizio.val()}T${elements.ora_inizio.val()}:00`,
                End: `${elements.data_fine.val()}T${elements.ora_fine.val()}:00`,
                AllDay: elements.all_day.prop('checked'),
                Description: elements.nota.val(),
                Enabled: false,
                IdTimeUnit:
                    elements.timeUnit.val() == '0' ? '-1' : elements.timeUnit.val(),
                IdPredefinedTimeUnit:
                    elements.predefinedTimeUnit.val() == '0'
                        ? '-1'
                        : elements.predefinedTimeUnit.val(),
                Units: elements.units.val() == '0' ? '-1' : elements.units.val(),
                MaxItems:
                    elements.maxItems.val() == '0' ? '-1' : elements.maxItems.val(),
                MaxDateTimeTo:
                    elements.maxDateTimeTo.val() != ''
                        ? elements.maxDateTimeTo.val()
                        : null,
                IdOriginal:
                    elements.idOriginal.val() == '0' ? '-1' : elements.idOriginal.val(),
                updateType: updateType,
                IdStato: elements.idStato.val(),
                HasRecurrencies: elements.hasRecurrencies.val(),
            };
            const date = elements.data_inizio.val();


            //modalEvent.modal('hide');
            application.ModalManagerIstance.hide('eventModal');

            await this.delay();

            application.ModalManagerIstance.show(application.LoadingModalIstance.Id);
            
            const saveResponse = await this.SaveEvent(event);

            if (saveResponse.IsSuccess) {
                if (this.airDatepicker || this.calendar) {

                    const getEventsResponse = await this.GetEvents(
                        this.getCalendarSelected(),
                        this.range[0],
                        this.range[1]
                    );
                    if (getEventsResponse.IsSuccess) {

                        this.events = this.convertFirstLetterToLower(getEventsResponse.Data);

                        if (this.calendar) {

                            this.calendar.removeAllEvents();

                            this.calendar.addEventSource(this.events);

                            this.calendar.render();
                        }

                        if (this.airDatepicker) {
                            this.airDatepicker.update();
                            const widgetEvents = $('#events');
                            if (widgetEvents) {
                                this.airDatepicker.selectDate(date);
                            }
                        }
                    } else {
                        throw new Error(`Scadenza salvata!<br>Errore aggiornamento lista scadenze.<br>${saveResponse.Message}`
                        );
                    }

                }
                if (this.afterSaveHandler) {
                    this.afterSaveHandler();
                }
            } else {
                throw new Error(saveResponse.Message);
            }
            await this.delay();
            setTimeout(() => {
                application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
            }, 700);
            
            application.SystemGenericModalIstance.Build(
                'Salvataggio completato',
                'I dati sono stati salvati correttamente.',
                'success',
                3000,
                false,
                '',
                null,
                false,
                '',
                null,
                true,
                'OK',
                () => { }
            );
            application.ModalManagerIstance.show(
                application.SystemGenericModalIstance.Id
            );
            this.closeModalEvent();
        } catch (e) {

            setTimeout(() => {
                application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
            }, 700);
            await this.delay();

            $('#error').html(e).removeClass('d-none');
            application.ModalManagerIstance.show('eventModal');
            //modalEvent.modal('show');
        }
    }

    async handleEventDelete(updateType) {
        application.LoadingModalIstance.Build(
            'Attendere',
            'Invio dati in corso...'
        );
        try {
            const elements = this.serializeEvent();
            const id = elements.id.val();
            const date = elements.data_inizio.val();

            this.closeModalEvent();
            await this.delay();
            application.ModalManagerIstance.show(application.LoadingModalIstance.Id);
            const response = await this.DeleteEvent(id, updateType);

            if (response.IsSuccess) {
                application.SystemGenericModalIstance.Build(
                    'Operazione riuscita',
                    "L'evento è stato eliminato correttamente.",
                    'success',
                    3000,
                    false,
                    '',
                    null,
                    false,
                    '',
                    null,
                    true,
                    'OK',
                    () => { }
                );
                application.ModalManagerIstance.show(
                    application.SystemGenericModalIstance.Id
                );

                setTimeout(function () { window.location = window.location.href; }, 50);
                


            } else {
                throw new Error(response.Message);
            }
        } catch (e) {
            setTimeout(() => {
                application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
            }, 700);
            await this.delay();
            application.SystemGenericModalIstance.Build(
                'Ops! qualcosa è andato storto.',
                e,
                'danger',
                15000,
                false,
                '',
                null,
                false,
                '',
                null,
                true,
                'OK',
                () => { }
            );
            application.ModalManagerIstance.show(
                application.SystemGenericModalIstance.Id
            );

        }
    }

    async handleCompleteEvent() {
        application.LoadingModalIstance.Build(
            'Attendere',
            'Invio dati in corso...'
        );
        try {
            const elements = this.serializeEvent();
            const date = elements.data_inizio.val();
            const id = $('#idEvento').val();
            if (id == 0) {
                throw new Error('Id evento non valido.');
            }

            this.closeModalEvent();
            await this.delay();
            application.ModalManagerIstance.show(application.LoadingModalIstance.Id);
            const response = await this.CompleteEvent(id);

            if (response.IsSuccess) {
                application.SystemGenericModalIstance.Build(
                    'Operazione riuscita',
                    "L'evento è stato completato correttamente.",
                    'success',
                    3000,
                    false,
                    '',
                    null,
                    false,
                    '',
                    null,
                    true,
                    'OK',
                    () => { }
                );
                application.ModalManagerIstance.show(
                    application.SystemGenericModalIstance.Id
                );

                await this.delay();

                setTimeout;
                const getEventsResponse = await this.GetEvents(
                    this.getCalendarSelected(),
                    this.range[0],
                    this.range[1]
                );
                if (getEventsResponse.IsSuccess) {
                    this.events = this.convertFirstLetterToLower(getEventsResponse.Data);

                    if (this.calendar) {

                        this.calendar.removeAllEvents();

                        this.calendar.addEventSource(this.events);

                        this.calendar.render();
                    }

                    if (this.airDatepicker) {
                        this.airDatepicker.update();
                        const widgetEvents = $('#events');
                        if (widgetEvents) {
                            this.airDatepicker.selectDate(date);
                        }
                    }
                } else {
                    throw new Error(`Scadenza completata!<br>Errore aggiornamento calendario scadenze.<br>${saveResponse.Message}`
                    );
                }
                setTimeout(() => {
                    application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
                }, 700);
            } else {
                throw new Error(response.Message);
            }
        } catch (e) {
            setTimeout(() => {
                application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
            }, 700);
            await this.delay();
            application.SystemGenericModalIstance.Build(
                'Ops! qualcosa è andato storto.',
                e,
                'danger',
                15000,
                false,
                '',
                null,
                false,
                '',
                null,
                true,
                'OK',
                () => { }
            );
            application.ModalManagerIstance.show(
                application.SystemGenericModalIstance.Id
            );

        }
    }

    async handleCancelEvent(updateType) {
        application.LoadingModalIstance.Build(
            'Attendere',
            'Invio dati in corso...'
        );
        try {
            const elements = this.serializeEvent();
            const id = elements.id.val();
            const date = elements.data_inizio.val();

            this.closeModalEvent();
            await this.delay();
            application.ModalManagerIstance.show(application.LoadingModalIstance.Id);
            const response = await this.CancelEvent(id, updateType);

            if (response.IsSuccess) {
                application.SystemGenericModalIstance.Build(
                    'Operazione riuscita',
                    "L'evento è stato annullato correttamente.",
                    'success',
                    3000,
                    false,
                    '',
                    null,
                    false,
                    '',
                    null,
                    true,
                    'OK',
                    () => { }
                );
                application.ModalManagerIstance.show(
                    application.SystemGenericModalIstance.Id
                );

                await this.delay();

                setTimeout;
                const getEventsResponse = await this.GetEvents(
                    this.getCalendarSelected(),
                    this.range[0],
                    this.range[1]
                );
                if (getEventsResponse.IsSuccess) {
                    this.events = this.convertFirstLetterToLower(getEventsResponse.Data);

                    if (this.calendar) {

                        this.calendar.removeAllEvents();

                        this.calendar.addEventSource(this.events);

                        this.calendar.render();
                    }

                    if (this.airDatepicker) {
                        this.airDatepicker.update();
                        const widgetEvents = $('#events');
                        if (widgetEvents) {
                            this.airDatepicker.selectDate(date);
                        }
                    }
                } else {
                    throw new Error(`Scadenza annullata!<br>Errore aggiornamento calendario scadenze.<br>${saveResponse.Message}`
                    );
                }
                setTimeout(() => {
                    application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
                }, 700);
            } else {
                throw new Error(response.Message);
            }
        } catch (e) {
            setTimeout(() => {
                application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
            }, 700);
            await this.delay();
            application.SystemGenericModalIstance.Build(
                'Ops! qualcosa è andato storto.',
                e,
                'danger',
                15000,
                false,
                '',
                null,
                false,
                '',
                null,
                true,
                'OK',
                () => { }
            );
            application.ModalManagerIstance.show(
                application.SystemGenericModalIstance.Id
            );

        }
    }

    eventValidator(elements) {
        try {
            let dateStart, dateEnd, timeStart, timeEnd;

            validate.extend(validate.validators.datetime, {
                parse: function (value, options) {
                    return +moment.utc(value);
                },
                format: function (value, options) {
                    var format = options.dateOnly ? 'YYYY-MM-DD' : 'YYYY-MM-DD hh:mm:ss';
                    return moment.utc(value).format(format);
                },
            });
            validate.validators.time = function (value, options, key, attributes) {
                if (!moment(value, 'HH:mm', true).isValid()) {
                    return options.message || "Il formato dell'orario deve essere HH:mm";
                }
            };
            validate.validators.dateTimeRange = function (
                value,
                options,
                key,
                attributes
            ) {
                var dateStart = value.dateStart;
                var dateEnd = value.dateEnd;

                var format = 'YYYY-MM-DDTHH:mm:ss';

                if (
                    !moment(dateStart, format, true).isValid() ||
                    !moment(dateEnd, format, true).isValid()
                ) {
                    return (
                        options.message ||
                        'Il formato della data e ora deve essere YYYY-MM-DDTHH:mm.'
                    );
                }

                if (!moment(dateEnd, format).isAfter(moment(dateStart, format))) {
                    return (
                        options.message ||
                        'La data di fine deve essere successiva alla data di inizio.'
                    );
                }
            };

            let schema = {
                titolo: {
                    presence: {
                        allowEmpty: false,
                        message: 'Il Titolo è obbligatorio.',
                    },
                    length: {
                        minimum: 5,
                        message: 'Il Titolo deve contenere almeno 5 caratteri.',
                    },
                },
                calendario: {
                    presence: {
                        allowEmpty: false,
                        message: 'Il Calendario è obbligatorio.',
                    },
                    numericality: {
                        greaterThan: 0,
                        message: 'Seleziona un Calendario.',
                    },
                },
                creator_user: {
                    presence: {
                        allowEmpty: false,
                        message: 'Il Proprietario è obbligatorio.',
                    },
                    numericality: {
                        greaterThan: 0,
                        message: 'Seleziona un Proprietario.',
                    },
                },
                priority: {
                    presence: {
                        allowEmpty: false,
                        message: 'La priorità è obbligatoria.',
                    },
                    numericality: {
                        greaterThan: 0,
                        message: 'Seleziona una Priorità.',
                    },
                },
                data_inizio: {
                    presence: {
                        allowEmpty: false,
                        message: 'Data inizio è obbligatoria.',
                    },
                    datetime: {
                        message: 'Formato non corretto.',
                    },
                },
                data_fine: {
                    presence: {
                        allowEmpty: false,
                        message: 'Data fine è obbligatoria.',
                    },
                    datetime: {
                        message: 'Formato non corretto.',
                    },
                },
                ora_inizio: {
                    presence: {
                        allowEmpty: true,
                        message: 'Ora inizio è obbligatoria.',
                    },
                    time: {
                        message: 'Formato non corretto.',
                    },
                },
                ora_fine: {
                    presence: {
                        allowEmpty: true,
                        message: 'Ora fine è obbligatoria.',
                    },
                    time: {
                        message: 'Formato non corretto.',
                    },
                },
                'cliente-select': {
                    presence: {
                        allowEmpty: false,
                        message: 'Il cliente è obbligatoria.',
                    },
                    numericality: {
                        greaterThan: 0,
                        message: 'Iserisci un Cliente',
                    },
                },
                dataEventoValida: {
                    dateTimeRange: {
                        message:
                            'La data e ora di fine deve essere maggio di quella di inizio.',
                    },
                },
            };

            for (const key in elements) {
                if (Object.prototype.hasOwnProperty.call(elements, key)) {
                    const element = elements[key];
                    let propName = element.attr('id');
                    let propValue = element.val();
                    let lblErrorMessage = $(`label.error[for="${propName}"]`);

                    element.removeClass('border-danger');
                    lblErrorMessage.hide();
                    lblErrorMessage.empty();

                    let resValidation = validate.single(propValue, schema[propName]);
                    if (resValidation) {
                        element.addClass('border-danger');
                        lblErrorMessage.text(resValidation);
                        lblErrorMessage.show();
                        throw new Error(
                            `Errorre validazione ${propName} valore ${propValue}`
                        );
                    }
                    switch (propName) {
                        case 'data_inizio':
                            dateStart = propValue;
                            break;
                        case 'data_fine':
                            dateEnd = propValue;
                            break;
                        case 'ora_inizio':
                            timeStart = propValue;
                            break;
                        case 'ora_fine':
                            timeEnd = propValue;
                            break;
                        default:
                            break;
                    }
                }
            }
            let resValidation = validate.single(
                {
                    dateStart: `${dateStart}T${timeStart}:00`,
                    dateEnd: `${dateEnd}T${timeEnd}:00`,
                },
                schema.dataEventoValida
            );
            if (resValidation) {
                alert(
                    "La data e l'ora di fine deve essere maggiore di quella di inizio."
                );
                throw new Error(
                    "La data e l'ora di fine deve essere maggiore di quella di inizio."
                );
            }
            return true;
        } catch (error) {
            
            return false;
        }
    }

    usersSelected(users) {
        const tagsContainer = document.getElementById('tags-container');
        tagsContainer.innerHTML = '';

        var selected = $('#utenti_selezionati').val();
        var selectedArray = selected ? selected.split(',') : [];

        users.each(function () {
            var value = $(this).val();
            var text = $(this).text();

            if (selectedArray.includes(value)) {
                const tag = document.createElement('div');
                tag.classList.add('tag');
                tag.dataset.id = value;

                const tagText = document.createElement('span');
                tagText.textContent = text;

                const removeButton = document.createElement('button');
                removeButton.classList.add('btn-close');

                removeButton.addEventListener('click', () => {
                    tag.remove();

                    updateHiddenInput(value, true);
                });

                tag.appendChild(tagText);
                tag.appendChild(removeButton);
                tagsContainer.appendChild(tag);
            }
        });
    }

    async GetTimeUnits() {
        try {
            const request = {
                method: 'post',
                url: '/HttpHandlers/GlobalCalendarManagementServiceAsync.ashx?action=TIMEUNITS',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {},
                timeout: 300000,
            };

            const result = await axios(request);

            if (result.status === 200) {
                return result.data;
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async GetEvents(idCalendarsSelected = [], start, end) {
        try {
            const request = {
                method: 'post',
                //url: 'SPCalendario.aspx/GetEvents',
                url: '/HttpHandlers/GlobalCalendarManagementServiceAsync.ashx?action=EVENTS',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {
                    idCalendars: idCalendarsSelected,
                    idExternal: 0,
                    idProfile: 0,
                    From: start,
                    To: end,
                },
                timeout: 300000,
            };

            const result = await axios(request);

            if (result.status === 200) {
                return result.data;
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async GetUsers(searchKey = '') {
        try {
            const request = {
                method: 'post',
                //url: 'SPCalendario.aspx/GetUsers',
                url: '/HttpHandlers/GlobalCalendarManagementServiceAsync.ashx?action=USERS',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {
                    searchKey: searchKey,
                },
                timeout: 300000,
            };

            const result = await axios(request);

            if (result.status === 200) {
                return result.data;
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async GetAssignableUsers(searchKey = '') {
        try {
            const request = {
                method: 'post',
                //url: 'SPCalendario.aspx/GetAssignableUsers',
                url: '/HttpHandlers/GlobalCalendarManagementServiceAsync.ashx?action=ASSIGNABLEUSERS',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {
                    searchKey: searchKey,
                },
                timeout: 300000,
            };

            const result = await axios(request);

            if (result.status === 200) {
                return result.data;
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async Setup(idCalendar, idCalendarsSelected = [], start, end, idCustomer = 0, idCommessa = 0, idOfferta = 0, CalendarIDsWithFreeUsers='') {
        try {
            const request = {
                method: 'post',
                url: '/HttpHandlers/GlobalCalendarManagementServiceAsync.ashx?action=INIT',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {
                    idCalendar: idCalendar,
                    idCalendars: idCalendarsSelected,
                    idExternal: 0,
                    idProfile: 0,
                    From: start,
                    To: end,
                    idCustomer: idCustomer,
                    idCommessa: idCommessa,
                    idOfferta: idOfferta,
                    CalendarIDsWithFreeUsers: CalendarIDsWithFreeUsers
                },
                timeout: 300000,
            };

            const result = await axios(request);
            
            if (result.status === 200) {
                return result.data; // JSON.parse(result.data);
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async GetUserCalendars(idCalendar = 0, idExternal = 0, idProfile = 0) {
        try {
            const request = {
                method: 'post',
                url: '/HttpHandlers/GlobalCalendarManagementServiceAsync.ashx?action=USERCALENDARS',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {
                    idCalendar: idCalendar,
                    idExternal: idExternal,
                    idProfile: idProfile,
                },
                timeout: 300000,
            };

            const result = await axios(request);

            if (result.status === 200) {
                return result.data;
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }
    async GetCustomers() {
        try {
            const request = {
                method: 'post',
                url: '/HttpHandlers/GlobalSearch.ashx',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {
                    searchKey: '',
                    includeClienti: true,
                    includeCommesse: false,
                    includeOfferte: false,
                    pageSize: -1,
                },
                timeout: 300000,
            };

            const result = await axios(request);

            if (result.status === 200) {
                return result.data.Data.Clienti;
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }
    async GetCustomerInfos(idCustomer = 0) {
        try {
            const request = {
                method: 'post',
                //url: 'SPCalendario.aspx/GetCustomerInfos',
                url: '/HttpHandlers/GlobalCalendarManagementServiceAsync.ashx?action=CUSTOMERINFO',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {
                    idCustomer: idCustomer,
                },
                timeout: 300000,
            };
            const result = await axios(request);
            if (result.status === 200) {
                return result.data;
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async GetEventPriorities() {
        try {
            
            const request = {
                method: 'post',
                //url: 'SPCalendario.aspx/GetEventPriorities',
                url: '/HttpHandlers/GlobalCalendarManagementServiceAsync.ashx?action=EVENTPRIORITIES',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {},
                timeout: 300000,
            };

            const result = await axios(request);
            
            if (result.status === 200) {
                return result.data;
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e.message);
        }

    }
    async GetScheduleTypesByCalendar(
        idCalendar = 0,
        idCliente = 0,
        idCommessa = 0,
        idOfferta = 0
    ) {
        try {
            const request = {
                method: 'post',
                //url: 'SPCalendario.aspx/GetScheduleTypesByCalendar',
                url: '/HttpHandlers/GlobalCalendarManagementServiceAsync.ashx?action=SCHEDULETYPESBYCALENDAR',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {
                    idCalendar: idCalendar,
                    idCliente: idCliente,
                    idCommessa: idCommessa,
                    idOfferta: idOfferta,
                },
                timeout: 300000,
            };

            const result = await axios(request);
            if (result.status === 200) {
                return result.data;
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }
    async SaveEvent(event) {
        try {
            const request = {
                method: 'post',
                //url: 'SPCalendario.aspx/SaveEvent',
                url: '/HttpHandlers/GlobalCalendarManagementServiceAsync.ashx?action=SAVE',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {
                    evento: event,
                },
                timeout: 300000,
            };

            const result = await axios(request);

            if (result.status === 200) {
                return result.data;
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }
    async DeleteEvent(Id, updateType) {
        try {
            const request = {
                method: 'post',
                url: '/HttpHandlers/GlobalCalendarManagementServiceAsync.ashx?action=DELETE',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {
                    Id: Id,
                    updateType: updateType,
                },
                timeout: 300000,
            };

            const result = await axios(request);

            if (result.status === 200) {
                return result.data;
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }
    async GetEventDetail(idCalendar, Id) {
        try {
            const request = {
                method: 'post',
                //url: 'SPCalendario.aspx/GetEventDetail',
                url: '/HttpHandlers/GlobalCalendarManagementServiceAsync.ashx?action=DETAIL',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {
                    idEvent: Id,
                    idCalendar: idCalendar,
                },
                timeout: 300000,
            };

            const result = await axios(request);

            if (result.status === 200) {
                return result.data;
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }
    async CompleteEvent(Id) {
        try {
            const request = {
                method: 'post',
                //url: 'SPCalendario.aspx/CompleteEvent',
                url: '/HttpHandlers/GlobalCalendarManagementServiceAsync.ashx?action=COMPLETE',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {
                    Id: Id,
                },
                timeout: 300000,
            };

            const result = await axios(request);

            if (result.status === 200) {
                return result.data;
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e);
        }
    }
    async CancelEvent(Id, updateType) {
        try {
            const request = {
                method: 'post',
                //url: 'SPCalendario.aspx/CancelEvent',
                url: '/HttpHandlers/GlobalCalendarManagementServiceAsync.ashx?action=CANCEL',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {
                    Id: Id,
                    updateType: updateType,
                },
                timeout: 300000,
            };

            const result = await axios(request);

            if (result.status === 200) {
                return result.data;
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e);
        }
    }
    async GetScheduleTypes() {
        try {
            const request = {
                method: 'post',
                //url: 'SPCalendario.aspx/GetScheduleTypes',
                url: '/HttpHandlers/GlobalCalendarManagementServiceAsync.ashx?action=SCHEDULETYPES',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {},
                timeout: 300000,
            };

            const result = await axios(request);

            if (result.status === 200) {
                return result.data;
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }
    async SaveCalendarDetail(Id, Title, Type, Color, AllUsers) {
        try {
            const request = {
                method: 'post',
                //url: 'SPCalendario.aspx/SaveCalendarDetail',
                url: '/HttpHandlers/GlobalCalendarManagementServiceAsync.ashx?action=SAVECALENDAR',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                data: {
                    calendarViewModel: {
                        Id: Id,
                        Title: Title,
                        PredefinedIdScheduleType: Type,
                        Color: Color,
                        AllUsers: AllUsers,
                        UserCalendar_IsVisible: true 
                    },
                },
                timeout: 300000,
            };

            const result = await axios(request);

            if (result.status === 200) {
                return result.data;
            } else {
                throw new Error(result.status);
            }
        } catch (e) {
            throw new Error(e);
        }
    }

    convertFirstLetterToLower(arr) {
        return arr.map((obj) => {
            let newObj = {};
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    let newKey = key.charAt(0).toLowerCase() + key.slice(1);
                    newObj[newKey] = obj[key];
                }
            }
            return newObj;
        });
    }

    renderSelectDropdown(
        select,
        data,
        labelKey,
        valueKey,
        editable,
        selectedValue
    ) {
        try {
            if (select) {
                select.empty();
                if (select.attr('id') != 'user-select') {
                    select.append('<option value="0">Seleziona</option>');
                }

                let SelectedValue_ToUse = selectedValue;
                    ;
                let Pippo = (((data && data.length == 1)) && (select.attr('id')=='type') );


                if (data && data.length > 0) {
                    for (let idx in data) {


                        const element = data[idx];

                        const optionValue = element[valueKey] || '';
                        const optionLabel = element[labelKey] || '';
                        const optionActive = element['Enabled'];

                        if (Pippo) {
                            Pippo = false;
                            if (selectedValue != undefined) {
                                if ((selectedValue != '') || (selectedValue != '0') || (selectedValue != '-1')) {
                                    SelectedValue_ToUse = selectedValue;
                                }
                                
                            }
                            else { SelectedValue_ToUse = element[valueKey]; }
                        }

                        select.append(
                            `<option value="${optionValue}" data-is-active="${optionActive}">${optionLabel}</option>`
                        );
                    }
                    if (SelectedValue_ToUse) {
                        if (SelectedValue_ToUse != '') {
                            $(select).val(SelectedValue_ToUse);
                        }
                        
                    }
                }

                if (editable != null && editable == false) {
                    
                    select.prop('disabled', true);
                } else {
                    select.removeProp('disabled');
                }
            }
        } catch (e) {
            throw new Error(e);
        }
    }

    renderCalendarList(
        container,
        data,
        labelKey,
        valueKey,
        editable,
        selectedValue
    ) {
        try {
            if (container) {
                container.empty();
                var template = document.getElementById('templateCalendarListItem');
                if (data && data.length > 0) {
                    for (let idx in data) {
                        const element = data[idx];
                        const optionValue = element[valueKey] || '';
                        const calendarLabel = element[labelKey] || '';
                        const calendarColor = element['Color'] || '';
                        const calendarIsPersonal = element['IsPersonal'];
                        const calendarAllUsers = element['AllUsers'];

                        const templateContent = template.content.cloneNode(true);

                        if (this.currentUserRights.canEditCalendar === true || calendarIsPersonal) {
                            templateContent.querySelector('.calendar-edit-button').classList.remove('d-none');
                        } else {
                            templateContent.querySelector('.calendar-edit-button').classList.add('d-none');
                        }
                        // Personalizza i contenuti della card
                        templateContent.querySelector('.calendar-name').textContent =
                            calendarLabel;

                        templateContent.querySelector('.calendar-checkbox').value =
                            element['Id'];

                        templateContent.querySelector('.calendar-checkbox').disabled = element['IsPersonal'];
                        templateContent.querySelector('.calendar-checkbox').checked = element['UserCalendar_IsVisible'];//dddd

                        templateContent.querySelector('.calendar-color').style.color =
                            calendarColor;
                        templateContent.querySelector('.calendar-predefined-idtype').value =
                            element['PredefinedIdScheduleType'];
                        templateContent
                            .querySelector('.calendar-checkbox')
                            .addEventListener('change', () => {
                                application.LoadingModalIstance.Build(
                                    'Attendere',
                                    'Aggiorno gli eventi...'
                                );
                                application.ModalManagerIstance.show(
                                    application.LoadingModalIstance.Id
                                );

                                this.GetEvents(this.getCalendarSelected(), this.range[0], this.range[1])
                                    .then((getEventsResponse) => {
                                        if (getEventsResponse.IsSuccess) {
                                            this.events = this.convertFirstLetterToLower(
                                                getEventsResponse.Data
                                            );
                                            this.calendar.removeAllEvents();
                                            this.calendar.addEventSource(this.events);
                                            this.calendar.render();
                                        } else {
                                            throw new Error(`Errore durante aggiornamento del calendario!<br>${saveResponse.Message}`
                                            );
                                        }
                                    })
                                    .catch((error) => {
                                        
                                    })
                                    .finally(() => {
                                        setTimeout(() => {
                                            application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
                                        }, 700);
                                    });
                            });
                        templateContent
                            .querySelector('#calendar-btn-edit')
                            .addEventListener('click', () => {
                                this.openModalNewCalendario(
                                    element['Id'],
                                    calendarLabel,
                                    element['PredefinedIdScheduleType'] || '0',
                                    calendarColor,
                                    calendarIsPersonal,
                                    calendarAllUsers
                                );
                            });
                        container.append(templateContent);
                    }
                }
            }
        } catch (e) {
            throw new Error(e);
        }
    }

    serializeEvent() {
        try {
            const elements = {
                id: $('#idEvento'),
                titolo: $('#titolo'),
                calendario: $('#calendario'),
                all_day: $('#all_day'),
                creator_user: $('#creator_user'),
                priority: $('#priority'),
                data_inizio: $('#data_inizio'),
                data_fine: $('#data_fine'),
                ora_inizio: $('#ora_inizio'),
                ora_fine: $('#ora_fine'),
                utenti_selezionati: $('#user-select'),
                cliente_select: $('#cliente-select'),
                commessa_select: $('#commessa-select'),
                offerta_select: $('#offerta-select'),
                type: $('#type'),
                nota: $('#nota'),
                timeUnit: $('#time-unit-selector'),
                predefinedTimeUnit: $('#recurrence-frequency'),
                units: $('#units'),
                maxDateTimeTo: $('#maxDateTimeTo'),
                maxItems: $('#maxItems'),
                idOriginal: $('#idOriginal'),
                updateType: $('#updateType'),
                idStato: $('#idStato'),
                hasRecurrencies: $('#has-recurrences'),
            };

            return elements;
        } catch (error) {
            throw new Error(error);
        }
    }

    renderCellConfig(date, cellType) {
        try {
            let config = {
                classes: '',
                html: date.getDate().toString(),
            };

            if (cellType === 'day' && this.hasAppointment(date)) {
                config.html = `<div class="has-appointment">${date.getDate()}</div>`;
                config.classes += ' appointment-day';
            }

            if (
                (this.viewMode === 'timeGridWeek' || this.viewMode === 'timeGridDay') &&
                this.isDateInRange(
                    moment(date).format('YYYY-MM-DD HH:mm:ss'),
                    this.range[0],
                    this.range[1]
                )
            ) {
                config.classes += ' -selected-';
            }

            config.classes = config.classes.trim();

            return config;
        } catch (error) {
            
            return {
                classes: '',
                html: date.getDate().toString(),
            };
        }
    }

    isDateInRange(date) {
        try {
            const check = moment(date, 'YYYY-MM-DD');
            const startDate = moment(this.range[0], 'YYYY-MM-DD');
            const endDate = moment(this.range[1], 'YYYY-MM-DD');

            return (
                check.isSameOrAfter(startDate, 'day') &&
                check.isSameOrBefore(endDate, 'day')
            );
        } catch (error) {
            
            return false;
        }
    }

    hasAppointment(date) {
        try {
            const formattedDate = moment(date).format('YYYY-MM-DD');

            let result = false;
            this.events.forEach((event) => {
                let dateEvent = moment(event.start).format('YYYY-MM-DD');
                if (dateEvent == formattedDate) {
                    result = true;
                }
            });
            return result;
        } catch (e) {
            
            return false;
        }
    }

    async handleDatesSet(dateInfo) {
        application.LoadingModalIstance.Build(
            'Attendere',
            'Caricamento dati in corso...'
        );
        application.ModalManagerIstance.show(application.LoadingModalIstance.Id);
        
        try {
            if (!this.isSyncing) {

                this.isSyncing = true;

                const start = moment(dateInfo.start);
                const end = moment(dateInfo.end).subtract(1, 'day');
                const centerDate = moment(start).add(
                    end.diff(start, 'days') / 2,
                    'days'
                );

                this.range = [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')];
                

                // Determina la vista corrente di FullCalendar
                const viewType = this.calendar.view.type;

                let selectedDates = [];
                if (viewType === 'dayGridMonth') {
                    // Vista Mese: Mostra solo il mese centrale
                    this.airDatepicker.setViewDate(centerDate.toDate());
                } else if (viewType === 'timeGridWeek') {
                    // Vista Settimana: Seleziona tutti i giorni della settimana corrente
                    let day = start.clone();
                    while (day.isBefore(end) || day.isSame(end, 'day')) {
                        selectedDates.push(day.toDate());
                        day.add(1, 'day');
                    }
                    this.airDatepicker.setViewDate(centerDate.toDate());
                    this.airDatepicker.selectDate(selectedDates);
                    this.airDatepicker.update();
                } else if (viewType === 'timeGridDay') {
                    // Vista Giorno: Seleziona solo il giorno corrente
                    selectedDates = [start.toDate()];
                    this.airDatepicker.setViewDate(centerDate.toDate());
                    this.airDatepicker.selectDate(selectedDates);
                    this.airDatepicker.update();
                }
                if (this.isRangeWithin(this.range)) {
                    this.isSyncing = false;
                    return;
                } else {
                    // Determina il range completo del mese per la fetch
                    let currentMonthStart = centerDate.clone().startOf('month');
                    let currentMonthEnd = centerDate.clone().endOf('month');

                    //  Riduzione periodo di cache

                    //  Originali
                    //  currentMonthStart = currentMonthStart.subtract(1, 'month').startOf('month');
                    //  currentMonthEnd = currentMonthEnd.add(3, 'months').endOf('month');

                    currentMonthStart = currentMonthStart.startOf('month');
                    currentMonthEnd = currentMonthEnd.endOf('month');

                    //  Fine Riduzione periodo di cache

                    const fetchStart = currentMonthStart.clone().startOf('week');
                    const fetchEnd = currentMonthEnd.clone().endOf('week');

                    this.rangeIniziale = [
                        fetchStart.format('YYYY-MM-DD'),
                        fetchEnd.format('YYYY-MM-DD'),
                    ];
                }

                await this.delay();
                // Aggiorna gli eventi di FullCalendar (opzionale se necessario)
                const calendarSelected = this.getCalendarSelected();
                const response = await this.GetEvents(
                    calendarSelected,
                    this.rangeIniziale[0],
                    this.rangeIniziale[1]
                );

                if (response.IsSuccess && response.Data.length > 0) {
                    this.events = this.convertFirstLetterToLower(response.Data);
                    this.calendar.removeAllEvents();
                    this.calendar.addEventSource(this.events);
                    this.calendar.render();
                    this.airDatepicker.setViewDate(centerDate.toDate());
                    this.airDatepicker.selectDate(selectedDates);
                    this.airDatepicker.update();
                } else {
                    throw new Error(`${response.Message}`);
                }

                this.isSyncing = false;
                //setTimeout(() => {
                //    application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
                //}, 700);
            }
        } catch (error) {
            
            this.isSyncing = false;
            //setTimeout(() => {
            //    application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
            //}, 700);
        } finally {
            this.isSyncing = false;
            setTimeout(() => {
                application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
                
            }, 700);
        }
    }

    isRangeWithin(newRange) {
        try {
            const startRangeIniziale = moment(this.rangeIniziale[0], 'YYYY-MM-DD');
            const endRangeIniziale = moment(this.rangeIniziale[1], 'YYYY-MM-DD');
            const startRange = moment(this.range[0], 'YYYY-MM-DD');
            const endRange = moment(this.range[1], 'YYYY-MM-DD');
            return (
                startRange.isSameOrAfter(startRangeIniziale) &&
                endRange.isSameOrBefore(endRangeIniziale)
            );
        } catch (e) {
            
            return true;
        }
    }

    handleDaySelect(date) {
        try {
            if (!this.isSyncing && date.formattedDate != null) {
                this.isSyncing = true;
                this.currentDate = moment(
                    date.formattedDate,
                    'DD/MM/YYYY',
                    true
                ).format('YYYY-MM-DD');
                range = [this.currentDate, this.currentDate];
                this.calendar.gotoDate(this.currentDate);
                this.calendar.select(this.currentDate);
                this.airDatepicker.clear();
                this.airDatepicker.update();
                this.isSyncing = false;
            }
        } catch (error) {
            this.isSyncing = false;
        }
    }

    delay(ms = 200) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    showSuggestions(suggestions, targetMenu, inputAutocomplete, inputValue) {
        const menu = document.getElementById(targetMenu);
        const input = document.getElementById(inputAutocomplete);
        const value = document.getElementById(inputValue);
        menu.innerHTML = '';

        if (suggestions.length === 0) {
            menu.style.display = 'none';
            return;
        }

        const rect = input.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;

        if (spaceBelow < 200 && spaceAbove > spaceBelow) {
            menu.style.marginTop = `-2${rect.height + 5}px`;
        } else {
            menu.style.marginTop = '5px';
        }

        suggestions.forEach((suggestion, index) => {
            const item = document.createElement('a');
            item.className = 'dropdown-item';
            item.textContent = suggestion.Name;

            item.addEventListener('click', () => {
                input.value = suggestion.Name;
                value.value = suggestion.ID;
                this.handleSelectedCliente();
                $('#cliente-select').trigger('change');
                menu.style.display = 'none';
                document.removeEventListener('click', handleClickOutside);
            });

            menu.appendChild(item);

            if (index < suggestions.length - 1) {
                const separator = document.createElement('hr');
                menu.appendChild(separator);
            }
        });
        menu.style.minWidth = `${rect.width}px`;
        menu.style.display = 'block';

        const handleClickOutside = (event) => {
            if (!menu.contains(event.target) && event.target.id !== 'cliente') {
                menu.style.display = 'none';
                document.removeEventListener('click', handleClickOutside);
            }
        };

        document.addEventListener('click', handleClickOutside);
    }

    getCalendarSelected() {
        const calendarSelected = [];
        document
            .querySelectorAll("input.calendar-checkbox[type='checkbox']:checked")
            .forEach((checkbox) => {
                calendarSelected.push(checkbox.value);
            });

        return calendarSelected;
    }
}

// Istanziamento della classe
